/* eslint-disable no-unused-vars, jsx-a11y/anchor-is-valid, no-script-url, default-case */
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

import Sidebar from "../Sidebar/Sidebar";
import HeaderNoDropdown from "../Header/HeaderNoDropdown";
import LanguageSelector from "../i18n/language-selector";
import {
  fetchProfile,
  Login,
  fetchWithTokenRefresh2,
  BASE_URL,
  VehicleRegistration_api,
  NotificationToggleStatus_api,
  EditProfile_api,
  DeviceId,
  OsVersion,
  ManufactureModel,
  App_version,
  NotificationToggleStatus_APIemailNotificationToggle,
  ToggleSyncBookingToggle_API,
  ChangePassword_API,
  Profile_api,
  GroupZoneList_API,
  VehicleRegistrationBulkAdd_API
} from "../apiUtils";
import { Support_api } from "./SettingReactAPI";
import { app } from "@microsoft/teams-js";
import { Images } from "../Common/Images.jsx";
import { getSessionLanguageCode } from "../../utils/CommonUtils.js"
import { getSSOLogin, setLanguage, getFirstname, hydrateProfileFromRecords } from "../../utils/SecurityService.js";
import CryptoJS from "crypto-js";
import { toast } from 'react-hot-toast';
import { handleApiResponse } from "../../hooks/notificationHelper.js";
import NotificationMessage from "../Common/NotificationMessage.jsx";

import graydelete from "../../assets/images/icons/gray-delete.svg"
import grayeye from "../../assets/images/icons/green-eye.svg";
import greeneye from "../../assets/images/icons/green-hide-eye.svg"
import redcross from "../../assets/images/icons/red-cross.svg"
import greencheck from "../../assets/images/icons/green-check.svg"
import steering from "../../assets/images/icons/steering.svg"
import fuel from "../../assets/images/icons/fuel.svg"
import carwithmark from "../../assets/images/icons/car-with-mark.svg"
import menwithcycle from "../../assets/images/icons/men-with-cycle.svg"
import whiteplus from "../../assets/images/icons/white-plus.svg"
import { useTranslation } from 'react-i18next'
import loadingGIF from "../../assets/images/loading.gif"
import Password from "./Password"
import Van from "../../assets/images/icons/van.svg";
import CompactCar from "../../assets/images/icons/compact-car.svg";
import RegularCar from "../../assets/images/icons/regular-car.svg";
import Motorbike from "../../assets/images/icons/motorbike.svg";
import Minibus from "../../assets/images/icons/minibus.svg";
import LargeCar from "../../assets/images/icons/large-car.svg"
import WarningIcon from "../../assets/images/icons/Warningicon.svg"
import helpTabIcon from "../../assets/images/icons/help-tab.svg"
import fileUploadIcon from "../../assets/images/icons/file-upload.svg"

import { useApiResponseHandler } from "../../hooks/useApiResponseHandler.js";
import useVehicleCardOrder, { buildOrderedVehicleGuIds } from "../../hooks/useVehicleCardOrder.js";
import closeIcon from "../../assets/images/icons/close.svg"
import greyUpDownArrow from "../../assets/images/icons/grey-up-down-arrow.svg"
import trashBlack from "../../assets/images/icons/trash-black.svg"
import trashRed from "../../assets/images/icons/trash-red.svg"
import Tooltipicon from "../../assets/images/icons/TooltipGreen.svg"
import NotificationPanel from '../Common/Notification'
import CreditInfoCard from '../Common/CreditInfoCard';
import DeleteAccount from "../Common/DeleteAccount";
import Notification from "../../assets/images/icons/notification.svg"
import {
  DELETE_ACCOUNT_RESPONSIVE_BYPASS_KEY,
  DELETE_ACCOUNT_STORAGE_KEY,
} from "../DeleteAccount/DeleteAccount.jsx";

import { AppConstant } from "../../config/AppConstants.js";
import { useApiUiResponse } from "../../hooks/apiUiResponseHelper.js";

export default function SettingReact() {
  const { t, i18n } = useTranslation()
  const history = useHistory();
  const [activeTab, setActiveTab] = useState("profile-setting");
  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false);
  const [isDeleteAccountEntryFlow, setIsDeleteAccountEntryFlow] = useState(false);
  const isSSOLogin = getSSOLogin();
  const tabContainerRef = useRef(null);
  const tabLineRef = useRef(null);
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    PrimaryEmail: "",
    allowedVehicleTypes: [],
    remindEmail: false,
    remindNotification: false,
    RegistrationName: ""
  });
  const [profiledata, setProfiledata] = useState({ syncCalendar: false })
  const [notificationsEnabled, setNotificationsEnabled] = useState(null);
  const [emailNotification, setEmailNotification] = useState(null)
  const [SyncCalendarStatus, setSyncCalendarStatus] = useState(null);
  const [vehicles, setVehicles] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [selectedZoneId, setSelectedZoneId] = useState(null);
  const [groupAccess, setGroupAccess] = useState(false);
  const [vehicleAccess, setVehicleAccess] = useState(false)
  const [parkingZonesAssigned, setParkingZonesAssigned] = useState(0);
  const [zones, setZones] = useState([]);
  const [AllowedVehicleTypes, setAllowedVehicleTypes] = useState([]);
  const [AllowedFuelTypes, setAllowedFuelTypes] = useState([]);
  const [AllowedAccessibleTypes, setAllowedAccessibleTypes] = useState([]);
  const [AllowedShareableTypes, setAllowedShareableTypes] = useState([]);

  const MAX_VEHICLES = 10;
  const [newVehicles, setNewVehicles] = useState([]);
  // Add vehicle size popup state
  const [addSizePopupVisible, setAddSizePopupVisible] = useState(null);

  // Add-vehicle popup: which draft's fuel/accessible/shareable dropdown is open
  const [openNewFuelDraftIndex, setOpenNewFuelDraftIndex] = useState(null);
  const [openNewAccessibleDraftIndex, setOpenNewAccessibleDraftIndex] = useState(null);
  const [openNewShareableDraftIndex, setOpenNewShareableDraftIndex] = useState(null);

  // Add-vehicle popup: currently selected type ids
  const [popupAllowedVehicleTypes, setPopupAllowedVehicleTypes] = useState(null);
  const [popupAllowedFuelTypes, setPopupAllowedFuelTypes] = useState(null);

  const [showPopup, setShowPopup] = useState(false);

  // Last vehicle list the profile API returned. Used when saving the order:
  // bulk-add refreshes the profile mid-save, so the newly created GuIds are read
  // from here instead of from `vehicles` state (which updates asynchronously).
  const vehiclesRef = useRef([]);

  // Card order + drag-to-reorder for the vehicle tab (saved vehicles and unsaved
  // add-vehicle drafts share one draggable list).
  const {
    cards: vehicleCards,
    dragKey: draggingCardKey,
    orderChanged: vehicleOrderChanged,
    cardDragProps,
    handleProps: dragHandleProps,
    cancelDrag: cancelVehicleDrag,
    getOrderSnapshot: getVehicleOrderSnapshot,
    resetOrderChanged: resetVehicleOrderChanged,
  } = useVehicleCardOrder({ vehicles, newVehicles, showDrafts: showPopup });

  const [notification, setNotification] = useState(null);

  const [originalDataforlocal, setOriginalDataforlocal] = useState(null);

  const [sizePopupVisible, setSizePopupVisible] = useState(false);
  const [activeVehicleForSize, setActiveVehicleForSize] = useState(null);

  const openSizePopup = (vehicle) => {
    setActiveVehicleForSize(vehicle);
    setSizePopupVisible(true);
  };

  const [validationError, setValidationError] = useState("");
  // Per-vehicle-field validation status: "error" (empty → red border + message) or
  // "success" (filled after being flagged → green border). Keyed by vehicle Id / draft index.
  const [vehicleFieldStatus, setVehicleFieldStatus] = useState({ existing: {}, drafts: {} });

  const [isGroupOpen, setIsGroupOpen] = useState(false);
  const [isZoneOpen, setIsZoneOpen] = useState(false);
  const groupRef = useRef(null);
  const zoneRef = useRef(null);

  const [selectedValue, setSelectedValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const rootRef = useRef(null);
  const Notifications = () => localStorage.getItem("Notifications");
  console.log("Notifications value in SettingReact:", Notifications());

  const [profileChanged, setProfileChanged] = useState(false);
  const [vehicleAdded, setVehicleAdded] = useState(false);
  const [vehicleUpdated, setVehicleUpdated] = useState(false);

  const [isCalendarSyncChanged, setIsCalendarSyncChanged] = useState(false);

  const [calendarChanged, setCalendarChanged] = useState(false);
  const [pushChanged, setPushChanged] = useState(false);
  const [emailChanged, setEmailChanged] = useState(false);

  // Language is staged on dropdown change and applied only on Save.
  const [languageChanged, setLanguageChanged] = useState(false);
  const [pendingLanguage, setPendingLanguage] = useState(null);

  const [toggleStncCalendar, setToggleStncCalendar] = useState()

  const [deletePopupVisible, setDeletePopupVisible] = useState(false);
  const [vehicleToDelete, setVehicleToDelete] = useState(null);

  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
  const [creditBalanceRefillEvery, setCreditBalanceRefillEvery] = useState("");
  const [zoneCreditValue, setZoneCreditValue] = useState(0);
  const [isThumbnailPresent, setIsThumbnailPresent] = useState(0);
  const [companyId, setCompanyId] = useState(0);
  const [creditBalance, setCreditBalance] = useState(0);

  const [openFuelVehicleId, setOpenFuelVehicleId] = useState(null);
  const [openAccessibleVehicleId, setOpenAccessibleVehicleId] = useState(null);
  const [openShareableVehicleId, setOpenShareableVehicleId] = useState(null);

  const [isOpenFnew, setIsOpenFnew] = useState(false);
  const [userName, setUserName] = useState("");

  // Need help? tab — wired to v5/Support_api (see SettingReactAPI.jsx).
  // Up to 3 image attachments; both text fields required (matches Android).
  const MAX_HELP_FILES = 3;
  const MAX_HELP_FILE_SIZE_MB = 5;
  const MAX_HELP_FILE_SIZE = MAX_HELP_FILE_SIZE_MB * 1024 * 1024; // 5 MB
  // Allowed attachment types: jpg, jpeg, png, tiff (and the .tif variant).
  const isAllowedHelpFile = (file) =>
    /^image\/(jpeg|png|tiff)$/i.test(file.type) ||
    /\.(jpe?g|png|tiff?)$/i.test(file.name);

  // Human-readable file size for the attachment cards (e.g. "200 KB", "1.4 MB").
  const formatFileSize = (bytes) => {
    if (typeof bytes !== "number" || Number.isNaN(bytes)) return "";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const [helpForm, setHelpForm] = useState({ shortDescription: "", stepsToReproduce: "" });
  const [helpFiles, setHelpFiles] = useState([]);
  const [helpErrors, setHelpErrors] = useState({ shortDescription: "", stepsToReproduce: "" });
  const helpStepsEditedRef = useRef(false);

  // Best-effort browser name + version for the support template (e.g. "Chrome 120.0").
  // Edge must be checked before Chrome because its UA string also contains "Chrome".
  const getBrowserVersion = () => {
    const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
    const patterns = [
      { name: "Edge", re: /Edg(?:e|A|iOS)?\/([\d.]+)/ },
      { name: "Chrome", re: /Chrome\/([\d.]+)/ },
      { name: "Firefox", re: /Firefox\/([\d.]+)/ },
      { name: "Safari", re: /Version\/([\d.]+).*Safari/ },
    ];
    for (const { name, re } of patterns) {
      const match = ua.match(re);
      if (match) return `${name} ${match[1]}`;
    }
    return ua;
  };

  // Editable email-style template prefilled into "Steps to reproduce" (mirrors Android).
  // %s is replaced with the logged-in user's first name, followed by a Browser Version line.
  const buildHelpStepsTemplate = () => {
    const name = userName || getFirstname() || "";
    // Some locale files store newlines as the literal characters "\n" (escaped) instead of
    // real line breaks; normalize so every language renders multi-line like English.
    // The placeholder case differs by locale (en/cs/fr/es/pt use %s; de/it/pl/nl use %S),
    // so match it case-insensitively to ensure the name is injected in every language.
    return t("help_steps_template")
      .replace(/\\n/g, "\n")
      .replace(/%s/i, `${name}\n${t("react_browser_ver")} : ${getBrowserVersion()}`);
  };

  // Open a locally-selected attachment in a new browser tab (client-side preview;
  // no upload involved). The object URL is revoked shortly after to free memory.
  const handleViewHelpFile = (file) => {
    const url = URL.createObjectURL(file);
    window.open(url, "_blank", "noopener,noreferrer");
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  };

  // Prefill the template once the user's name is known (and on language change),
  // unless the user has already edited the field.
  useEffect(() => {
    if (helpStepsEditedRef.current) return;
    setHelpForm((prev) => ({ ...prev, stepsToReproduce: buildHelpStepsTemplate() }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userName, t]);

  // Validation message shown below each field when it is left empty.
  const helpEmptyFieldMessages = {
    shortDescription: "please_add_a_short_description_of_problem",
    stepsToReproduce: "please_add_steps_to_reproduce_the_problem",
  };

  const handleHelpInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "stepsToReproduce") helpStepsEditedRef.current = true;
    setHelpForm((prev) => ({ ...prev, [name]: value }));
    // Show the red validation message live when the field is emptied; clear it once text is present.
    setHelpErrors((prev) => ({
      ...prev,
      [name]: value.trim() ? "" : t(helpEmptyFieldMessages[name] || ""),
    }));
  };

  // Inline validation (errors shown below each field) — replaces disabling the Send button.
  const validateHelpForm = () => {
    const newErrors = { shortDescription: "", stepsToReproduce: "" };
    let isValid = true;

    if (!helpForm.shortDescription.trim()) {
      newErrors.shortDescription = t("please_add_a_short_description_of_problem");
      isValid = false;
    }
    if (!helpForm.stepsToReproduce.trim()) {
      newErrors.stepsToReproduce = t("please_add_steps_to_reproduce_the_problem");
      isValid = false;
    }

    setHelpErrors(newErrors);
    return isValid;
  };

  const handleHelpFileChange = (e) => {
    const selected = Array.from(e.target.files || []);
    e.target.value = ""; // allow re-selecting the same file after add/rejection
    if (selected.length === 0) return;

    const remainingSlots = MAX_HELP_FILES - helpFiles.length;
    if (remainingSlots <= 0) {
      toast.error(t("max_attachments_reached"));
      return;
    }

    const accepted = [];
    for (const file of selected) {
      if (!isAllowedHelpFile(file)) { toast.error(t("only_jpg_allowed")); continue; }
      if (file.size > MAX_HELP_FILE_SIZE) { toast.error(t("maximum_file_size_allowed_s_mb").replace("%s", String(MAX_HELP_FILE_SIZE_MB))); continue; }
      accepted.push(file);
    }
    if (accepted.length > remainingSlots) toast.error(t("max_attachments_reached"));

    setHelpFiles((prev) => [...prev, ...accepted].slice(0, MAX_HELP_FILES));
  };

  const handleRemoveHelpFile = (index) => {
    setHelpFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleHelpCancel = () => {
    helpStepsEditedRef.current = false;
    setHelpForm({ shortDescription: "", stepsToReproduce: buildHelpStepsTemplate() });
    setHelpFiles([]);
    setHelpErrors({ shortDescription: "", stepsToReproduce: "" });
  };

  const handleHelpGoToHelpCentre = () => {
    const url = AppConstant.HELP_CENTRE;
    // In the Teams desktop/mobile client, app.openLink reliably opens the link in the
    // user's default browser. Fall back to window.open for the Teams web client / browser.
    Promise.resolve()
      .then(() => app.openLink(url))
      .catch(() => window.open(url, "_blank", "noopener,noreferrer"));
  };

  const handleHelpSend = async () => {
    if (!validateHelpForm()) return; // show inline errors instead of disabling the button

    const title = helpForm.shortDescription.trim();
    const body = helpForm.stepsToReproduce.trim();

    try {
      setIsLoading(true);

      const response = await Support_api({ Title: title, Body: body, files: helpFiles });
      const { ResponseCode, Records } = response.Data;

      handleApiUiResponse(response, {
        successToaster: 1,
        errorToaster: 1,
        alertPopup: 1
      });

      if (ResponseCode === 200) {
        handleHelpCancel();
      }
    } catch (error) {
      toast.error(t("react_error_operation"));
    } finally {
      setIsLoading(false);
    }
  };

  const { handleApiUiResponse, renderApiUi } = useApiUiResponse(t);

  // Terms & privacy URL for the session's language (2-letter i18n code), with English fallback.
  const termsLanguageCode = (i18n.language || "en").split("-")[0];
  const termsUrl = AppConstant.TERMS_LINKS[termsLanguageCode] || AppConstant.TERMS_LINKS.en;

  const [touched, setTouched] = useState({
    firstName: false,
    lastName: false
  });

  const openDeletePopup = (vehicle) => {
    setVehicleToDelete(vehicle);
    setDeletePopupVisible(true);
  };

  const {
    handleResponseCode,
    showAlertPopupModal,
    alertPopupModalData,
    showErrorPopupModal,
    errorPopupModalData,
    setShowAlertPopupModal,
    setShowErrorPopupModal
  } = useApiResponseHandler();

  const getVehicleIconById = (typeId) => {
    // Use the ID from your AllowedVehicleTypes data
    switch (parseInt(typeId)) {
      case 1: return CompactCar;    // Assuming 1 is Large
      case 2: return RegularCar;  // Assuming 2 is Regular
      case 3: return LargeCar;  // Assuming 3 is Compact
      case 4: return Motorbike;      // Assuming 4 is Van
      case 5: return Van;// Assuming 5 is Motorbike
      case 6: return Minibus;  // Assuming 6 is Minibus
      // default: return VehicleLarge;
    }
  };

  const getGuId = () => localStorage.getItem("guId");

  // Client-side id for add-vehicle drafts. Drafts have no server id until they
  // are saved, so the card order (see useVehicleCardOrder) needs a stable key
  // that survives typing, reordering and sibling removal.
  const draftUidRef = useRef(0);

  const createEmptyVehicleDraft = () => ({
    uid: ++draftUidRef.current,
    VehicleNumber: "",
    VehicleSizeId: "",
    VehicleFuelId: "",
    VehicleAccessibleId: 0,
    VehicleShareableId: 0,
  });

  const updateNewVehicleDraft = (draftIndex, updates) => {
    setNewVehicles((prevVehicles) =>
      prevVehicles.map((vehicle, index) =>
        index === draftIndex ? { ...vehicle, ...updates } : vehicle
      )
    );
  };

  const removeNewVehicleDraft = (draftIndex) => {
    const updatedVehicles = newVehicles.filter((_, index) => index !== draftIndex);
    setNewVehicles(updatedVehicles);
    if (updatedVehicles.length === 0) {
      setShowPopup(false);
      setVehicleAdded(false);
    }
    setValidationError("");
    setVehicleFieldStatus({ existing: {}, drafts: {} });
    setOpenNewFuelDraftIndex(null);
    setOpenNewAccessibleDraftIndex(null);
    setOpenNewShareableDraftIndex(null);
    setAddSizePopupVisible((currentIndex) => (currentIndex === draftIndex ? null : currentIndex));
  };

  // const selectedGroupName =
  //   groups.find((group) => group.Id === selectedGroupId)?.Name ||
  //   "-- Select a Group --";

  const selectedGroupName =
    selectedGroupId === 0
      ? " -- "
      : (groups.find((g) => g.Id === selectedGroupId)?.Name || t("select_group"));

  // const selectedZoneName =
  //   zones.find((zone) => zone.Id === selectedZoneId)?.ZoneName ||
  //   "-- Select a Zone --";
  // const selectedZoneName =
  //   zones.find((zone) => zone.Id === selectedZoneId)?.ZoneName ||
  //   "-- Select a Zone --";
  const selectedZoneName =
    zones.find((zone) => Number(zone.Id) === Number(selectedZoneId))?.ZoneName || t("select_a_zone");

  // const selectedOption = options.find((option) => option.value === selectedValue);
  // const selectedLabel = selectedOption ? selectedOption.label : "Select an option";


  const toggleGroupDropdown = () => {
    setIsGroupOpen(!isGroupOpen);
    setIsZoneOpen(false); // Close the other dropdown
  };

  const toggleZoneDropdown = () => {
    setIsZoneOpen(!isZoneOpen);
    setIsGroupOpen(false); // Close the other dropdown
  };

  const isTeamsSession = Boolean(sessionStorage.getItem("msHomeAccountId"));

  useEffect(() => {
    const shouldOpenDeleteAccount = localStorage.getItem(DELETE_ACCOUNT_STORAGE_KEY) === "1";

    if (!shouldOpenDeleteAccount) {
      return;
    }

    setIsDeleteAccountEntryFlow(true);
    setShowDeleteAccountModal(true);
    localStorage.removeItem(DELETE_ACCOUNT_STORAGE_KEY);
  }, []);

  const handleDeleteAccountModalClose = () => {
    setShowDeleteAccountModal(false);

    if (isDeleteAccountEntryFlow) {
      setIsDeleteAccountEntryFlow(false);
      localStorage.removeItem(DELETE_ACCOUNT_RESPONSIVE_BYPASS_KEY);
      sessionStorage.clear();
      localStorage.clear();
      history.replace("/");
    }
  };


  useEffect(() => {
    document.title = `${t("react_profile")} | Ronspot`
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (groupRef.current && !groupRef.current.contains(event.target)) {
        setIsGroupOpen(false);
      }
      if (zoneRef.current && !zoneRef.current.contains(event.target)) {
        setIsZoneOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  // Only update tab underline on tab change
  useEffect(() => {
    const updateTabLine = () => {
      if (tabContainerRef.current && tabLineRef.current) {
        const activeTabElement = tabContainerRef.current.querySelector(".nav-link.active");
        if (activeTabElement) {
          const left = activeTabElement.offsetLeft;
          const width = activeTabElement.offsetWidth;
          tabLineRef.current.style.left = `${left}px`;
          tabLineRef.current.style.width = `${width}px`;
        }
      }
    };
    window.addEventListener("resize", updateTabLine);
    setTimeout(updateTabLine, 0);
    return () => {
      window.removeEventListener("resize", updateTabLine);
    };
  }, [activeTab]);

  useEffect(() => {
    if (isSSOLogin && isTeamsSession && activeTab === "password-setting") {
      setActiveTab("profile-setting");
    }
  }, [activeTab, isSSOLogin, isTeamsSession]);

  useEffect(() => {
    if (parkingZonesAssigned !== 1 && activeTab === "vehicle-setting") {
      setActiveTab("profile-setting");
    }
  }, [activeTab, parkingZonesAssigned]);

  // Only call fetchData on initial mount
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (profile && profile.Data && profile.Data.Records) {
      const status = profile.Data.Records.EmailNotificationsStatus;
      const calendarStatus = profile.Data.Records.SyncCalendarStatus;
      // If status is "1", set to true; otherwise false
      setEmailNotification(status === "1" || status === 1);
      setSyncCalendarStatus(calendarStatus === "1" || calendarStatus === 1)
    }
  }, [profile]);


  useEffect(() => {
    if (profile?.Data?.Records) {
      const record = profile.Data.Records;

      // Define the baseline values
      const baseEmail = record.EmailNotificationsStatus === "1" || record.EmailNotificationsStatus === 1;
      const baseCalendar = record.SyncCalendarStatus === "1" || record.SyncCalendarStatus === 1;
      const basePush = record.PushNotificationsStatus === "1" || record.PushNotificationsStatus === 1;

      // Save to the Snapshot (OriginalData)
      setOriginalDataforlocal({
        firstName: record.FirstName || "",
        lastName: record.LastName || "",
        primaryEmail: record.PrimaryEmail || "",
        emailNotification: baseEmail,
        syncCalendar: baseCalendar,
        pushNotification: basePush,
        vehicles: record.Vehicles || [],
        groups: record.Groups || []
      });
    }
  }, [profile]);


  // VehicleType
  useEffect(() => {
    // If we have vehicle types and nothing is selected yet, pick the first one
    if (AllowedVehicleTypes?.length > 0 && !popupAllowedVehicleTypes) {
      setPopupAllowedVehicleTypes(AllowedVehicleTypes[0].Id);
    }
  }, [AllowedVehicleTypes, popupAllowedVehicleTypes]);

  //fuletype
  useEffect(() => {
    if (AllowedFuelTypes?.length > 0 && !popupAllowedFuelTypes) {
      setPopupAllowedFuelTypes(AllowedFuelTypes[0].Id);
    }
  }, [AllowedFuelTypes, popupAllowedFuelTypes]);

  const handleInputChangeProfile = (e) => {
    const { name, value } = e.target;

    // const cleanValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));

    setProfileChanged(true);
  };

  const profileValidations = {
    firstNameHasSpace: /\s/.test(formData.firstName),
    lastNameHasSpace: /\s/.test(formData.lastName),

    firstNameEmpty: !formData.firstName || formData.firstName.trim() === "",
    lastNameEmpty: !formData.lastName || formData.lastName.trim() === ""
  };
  const profileHasSpaces = /\s/.test(formData.firstName) || /\s/.test(formData.lastName);

  const profileHasEmpty = !formData.firstName || formData.firstName.trim() === "" || !formData.lastName || formData.lastName.trim() === ""
  // Update your main save button logic to include these:
  const isProfileValid = !profileValidations.firstNameHasSpace &&
    !profileValidations.lastNameHasSpace &&
    !profileValidations.firstNameEmpty &&
    !profileValidations.lastNameEmpty


  const handleVehicleInputChange = (event, id) => {
    const { value } = event.target;

    // const cleanValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
    setVehicles((prevVehicles) =>
      prevVehicles.map((v) =>
        v.Id === id ? { ...v, RegistrationName: value } : v
      )
    );
    setVehicleUpdated(true);
    // Only react once this field has been validated: empty → keep red, filled → turn green.
    setVehicleFieldStatus((prev) => {
      if (!prev.existing[id]) return prev;
      const nextExisting = { ...prev.existing, [id]: value.trim() !== "" ? "success" : "error" };
      return { ...prev, existing: nextExisting };
    });
  };

  const handleFuelTypeChange = (vehicleId, fuelName, fuelId) => {
    // 1. Update the state
    setVehicles((prevVehicles) =>
      prevVehicles.map((v) =>
        v.Id === vehicleId ? { ...v, FuelType: fuelName, FuelId: fuelId } : v
      )
    );

    // 2. Trigger the change flag so the Save button works
    setVehicleUpdated(true);
  };

  const handleAccessibleTypeChange = (vehicleId, accessibleName, accessibleId) => {
    // 1. Update the state
    setVehicles((prevVehicles) =>
      prevVehicles.map((v) =>
        v.Id === vehicleId ? { ...v, AccessibleType: accessibleName, AccessibleId: accessibleId } : v
      )
    );

    // 2. Trigger the change flag so the Save button works
    setVehicleUpdated(true);
  };

  const handleSharingTypeChange = (vehicleId, sharingName, sharingId) => {
    // 1. Update the state
    setVehicles((prevVehicles) =>
      prevVehicles.map((v) =>
        v.Id === vehicleId ? { ...v, ShareableType: sharingName, ShareableId: sharingId } : v
      )
    );

    // 2. Trigger the change flag so the Save button works
    setVehicleUpdated(true);
  };

  const handleGroupChange = (event) => {
    const newGroupId = parseInt(event.target.value);
    setSelectedGroupId(newGroupId);
    setProfileChanged(true); // This tells handleSaveAll to include this in the update
    fetchZonesForGroup(newGroupId);
  };
  //   const handleGroupChange = async (e) => {
  //   const newGroupId = e.target.value;
  //   setSelectedGroupId(newGroupId);

  //   // 1. Reset the current zone selection
  //   setSelectedZoneId(0); 
  //   setSelectedZoneName("--"); 

  //   // 2. Clear current zones list while loading new ones
  //   setZones([]); 

  //   // 3. Fetch new zones based on the new Group ID
  //   if (newGroupId !== 0) {
  //     try {
  //       // Replace this with your actual API call for fetching zones
  //       const response = await fetchZonesByGroupId(newGroupId); 
  //       setZones(response.data || []);
  //     } catch (error) {
  //       console.error("Error fetching zones:", error);
  //     }
  //   }
  // };


  const handleZoneChange = (zoneId) => {
    // Directly pass the ID instead of an event if using a custom div/click handler
    const idAsNumber = parseInt(zoneId);
    setSelectedZoneId(idAsNumber);
    setProfileChanged(true);
  };
  // const handleZoneChange = (event) => {
  //   setSelectedZoneId(parseInt(event.target.value));
  //   setProfileChanged(true);
  // };

  //ToggleSyncbookingswithcalenda Toggle
  // const ToggleSyncbookingswithcalenda = () => {
  //   const newValue = !SyncCalendarStatus;

  //   // Update UI immediately
  //   setSyncCalendarStatus(newValue);

  //   const updateNotifications = async (val) => {
  //     try {
  //       const response = await fetchWithTokenRefresh2(BASE_URL + ToggleSyncBookingToggle_API, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
  //         },
  //         body: JSON.stringify({
  //           GuId: `${localStorage.getItem("guId")}`,
  //           // GuId: "EB85CA39-72E6-43EA-468A-7A454D363462",
  //           Language: getSessionLanguageCode(),
  //           DeviceId: DeviceId,
  //           OsVersion: OsVersion,
  //           ManufactureModel: ManufactureModel,
  //           AppVersion: App_version,
  //           Status: val ? "1" : "0"
  //         }),
  //       });

  //       const result = handleResponseCode(response);

  //       const responseData = await response.json();
  //       const isOk = CustomSuccessToast(responseData)


  //       // if (response.ok) 
  //       if (result.success || (response && result.code === 200)) {
  //         // localStorage.setItem("Notifications", val ? "1" : "0");
  //         // alert("Your changes have been saved successfully ✅");
  //       }
  //     } catch (updateError) {
  //       console.error("Error updating notifications:", updateError);
  //       setError(updateError.message);
  //       setNotificationsEnabled(!newValue);
  //     }
  //   };

  //   updateNotifications(newValue);
  // };

  // Step 1: Add a state flag at the top of your component

  //handleNotificationsToggle
  // Step 2: Update the toggle function
  //  const handleNotificationsToggle = () => {
  //     const newValue = !notificationsEnabled;

  //     // Update UI immediately
  //     setNotificationsEnabled(newValue);

  //     const updatePushNotifications = async (val) => {
  //       try {
  //         const response = await fetchWithTokenRefresh2(BASE_URL + NotificationToggleStatus_api, {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
  //           },
  //           body: JSON.stringify({
  //             GuId: localStorage.getItem("guId"),
  //             NotificationStatus: val ? "1" : "0",
  //             // ... other required fields like DeviceId, AppVersion, etc.
  //           }),
  //         });

  //         const responseData = await response.json()
  //         const success = CustomSuccessToast(responseData)

  //         if (response.ok) {
  //           // 2. Update session storage so it stays consistent on page reload
  //           localStorage.setItem("Notifications", val ? "1" : "0");
  //           // alert("Your changes have been saved successfully ✅");
  //         } else {
  //           throw new Error("Failed to update notification status");
  //         }
  //       } catch (err) {
  //         console.error(err);
  //         // Revert UI on error
  //         setNotificationsEnabled(!val);
  //       }
  //     };

  //     updatePushNotifications(newValue);
  //   };

  //handleNotificationsEmail
  //   const handleNotificationsEmail = () => {
  //     setEmailNotification(!emailNotification);

  //     const updateNotifications = async (newValue) => {
  //       try {
  //         const response = await fetchWithTokenRefresh2(BASE_URL + NotificationToggleStatus_APIemailNotificationToggle, {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
  //           },
  //           body: JSON.stringify({
  //             GuId: `${localStorage.getItem("guId")}`,
  //             // GuId: "EB85CA39-72E6-43EA-468A-7A454D363462",
  //             Language: getSessionLanguageCode(),
  //             DeviceId: DeviceId,
  //             OsVersion: OsVersion,
  //             ManufactureModel: ManufactureModel,
  //             AppVersion: App_version,
  //             NotificationStatus: newValue ? "1" : "0"
  //           }),
  //         });

  //         const responseData = await response.json();
  //         const isOk = CustomSuccessToast(responseData)

  //         if (response.ok) {
  //           // alert("Email notficatoin")
  //         }
  //       } catch (updateError) {
  //         console.error("Error updating notifications:", updateError);
  //         setError(updateError.message);
  //         setEmailNotification(!newValue);
  //       }
  //     };

  //     updateNotifications(!emailNotification);
  //   };




  const updatePushStatus = async () => {
    const response = await fetchWithTokenRefresh2(BASE_URL + NotificationToggleStatus_api, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        GuId: localStorage.getItem("guId"),
        NotificationStatus: notificationsEnabled ? "1" : "0",
        Language: getSessionLanguageCode(),
        DeviceId: DeviceId,
        OsVersion: OsVersion,
        ManufactureModel: ManufactureModel,
        AppVersion: App_version,
      }),
    });
    return await response.json();
  };

  const updateEmailStatus = async () => {
    const response = await fetchWithTokenRefresh2(BASE_URL + NotificationToggleStatus_APIemailNotificationToggle, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        GuId: localStorage.getItem("guId"),
        NotificationStatus: emailNotification ? "1" : "0",
        Language: getSessionLanguageCode(),
        DeviceId: DeviceId,
        OsVersion: OsVersion,
        ManufactureModel: ManufactureModel,
        AppVersion: App_version,
      }),
    });
    return await response.json();
  };

  const updateCalendarSettings = async () => {
    const response = await fetchWithTokenRefresh2(BASE_URL + ToggleSyncBookingToggle_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        GuId: localStorage.getItem("guId"),
        Language: getSessionLanguageCode(),
        DeviceId: DeviceId,
        OsVersion: OsVersion,
        ManufactureModel: ManufactureModel,
        AppVersion: App_version,
        Status: SyncCalendarStatus ? "1" : "0"
      }),
    });
    return await response.json();
  };

  const ToggleSyncbookingswithcalenda = () => {
    const newValue = !SyncCalendarStatus;

    setSyncCalendarStatus(newValue); // Updates the checkbox UI
    setCalendarChanged(true);        // Tells handleSaveAll that this needs saving
  };

  const handleNotificationsToggle = () => {
    setNotificationsEnabled(!notificationsEnabled);
    setPushChanged(true); // Flag for Save button
  };

  const syncNotificationsToggleFromPanel = (checked) => {
    setNotificationsEnabled(checked);
  };

  const handleNotificationsEmail = () => {
    setEmailNotification(!emailNotification);
    setEmailChanged(true); // Flag for Save button
  };


  const handlepopupVehicleChange = (event) => {
    setValidationError("");
    const vehicleTypeId = parseInt(event.target.value);
    const draftIndex = parseInt(event.target.dataset.draftIndex, 10);
    updateNewVehicleDraft(draftIndex, { VehicleSizeId: vehicleTypeId });
  };
  // const handlepopupFuleTypeChange = (event) => {
  //   setValidationError("");
  //   setPopupAllowedFuelTypes(parseInt(event.target.value));
  // };
  // const handlepopupShareableTypesChange = (event) => {
  //   setValidationError("");
  //   setPopupAllowedShareableTypes(parseInt(event.target.value));
  // };
  // const handlepopupAccessibleTypesChange = (event) => {
  //   setValidationError("");
  //   setPopupAllowedAccessibleTypes(parseInt(event.target.value));
  // };
  const handlepopupFuleTypeChange = (draftIndex, id) => {
    setValidationError("");
    updateNewVehicleDraft(draftIndex, { VehicleFuelId: parseInt(id) });
  };
  const handlepopupShareableTypesChange = (draftIndex, id) => {
    setValidationError("");
    updateNewVehicleDraft(draftIndex, { VehicleShareableId: parseInt(id) });
  };

  const handlepopupAccessibleTypesChange = (draftIndex, id) => {
    setValidationError("");
    updateNewVehicleDraft(draftIndex, { VehicleAccessibleId: parseInt(id) });
  };


  const handleAddVehicleClick = (e) => {
    e.preventDefault();
    const totalVehicles = vehicles.length + newVehicles.length;
    if (totalVehicles >= MAX_VEHICLES) {
      toast.error(`You can add up to ${MAX_VEHICLES} vehicles only.`);
      return;
    }

    const nextDraft = createEmptyVehicleDraft();
    if (AllowedVehicleTypes?.length > 0) {
      nextDraft.VehicleSizeId = AllowedVehicleTypes[0].Id;
    }
    if (AllowedFuelTypes?.length > 0) {
      nextDraft.VehicleFuelId = AllowedFuelTypes[0].Id;
    }

    setNewVehicles((prevVehicles) => [...prevVehicles, nextDraft]);
    setValidationError("");
    setVehicleAdded(true);
    setOpenNewFuelDraftIndex(null);
    setOpenNewAccessibleDraftIndex(null);
    setOpenNewShareableDraftIndex(null);
    setShowPopup(true);
  };

  // Move fetchData above handlers so it's defined before use
  const fetchData = async (isSilent = false) => {
    // setIsLoading(true);
    if (!isSilent) setIsLoading(true);
    setError(null);
    const notificationValue = localStorage.getItem("ReminderNotifications");
    try {
      // if (notificationValue == "1") {
      //   setNotificationsEnabled(true);
      // } else {
      //   setNotificationsEnabled(false);
      //   console.warn("Notifications value not found or invalid:");
      // }
      const profileData = await fetchProfile();
      handleApiUiResponse(profileData, {
        successToaster: 0,
        errorToaster: 1,
        alertPopup: 1
      });
      setToggleStncCalendar(profileData?.Data?.Records?.SyncCalendarStatus);
      if (!profileData || !profileData.Data || !profileData.Data.Records) {
        throw new Error("Failed to fetch profile: Invalid response from server");
      }
      if (profileData.Data.Records.SyncCalendarStatus === 1) {
        setSyncCalendarStatus(true);
      }
      if (profileData && profileData.Data && profileData.Data.Records && profileData.Data.Records.Vehicles) {
        vehiclesRef.current = profileData.Data.Records.Vehicles;
        setVehicles(profileData.Data.Records.Vehicles);
      }
      const records = profileData.Data.Records;
      hydrateProfileFromRecords(records);

      setUserName(records.FirstName)
      setCreditBalance(records.CreditBalance);
      setCompanyId(records.CompanyId);
      setCreditBalanceRefillEvery(records.CreditBalanceRefillEvery);
      setZoneCreditValue(String(records.ZoneCreditValue ?? "0"));
      setIsThumbnailPresent(records.IsThumbnailPresent);

      // 2. SET IN SESSION STORAGE HERE
      // Assuming NotificationsStatus is 1 for enabled and 0 for disabled
      const notifStatus = String(records.NotificationsStatus);
      localStorage.setItem("ReminderNotifications", notifStatus);

      const firstName = records.FirstName
      localStorage.setItem("firstname", firstName);
      const lastName = records.LastName
      localStorage.setItem("lastname", lastName);

      // 3. Update the State based on the fresh API data
      setNotificationsEnabled(notifStatus === "1");
      setProfile(profileData);
      setFormData({
        firstName: profileData.Data.Records.FirstName || "",
        lastName: profileData.Data.Records.LastName || "",
        PrimaryEmail: profileData.Data.Records.PrimaryEmail || "",
        allowedVehicleTypes:
          profileData.Data.Records.AllowedVehicleTypes?.map((vehicle) => vehicle.Name) || [],
      });
      if (profileData.Data.Records.Groups) {
        setGroups(profileData.Data.Records.Groups);
        setSelectedGroupId(profileData.Data.Records.GroupId);
        setSelectedZoneId(profileData.Data.Records.ZoneId);
        setGroupAccess(profileData.Data.Records.EnableGroups);
        setVehicleAccess(profileData.Data.Records.DisableVehicles)
      }
      setParkingZonesAssigned(Number(records.ParkingZonesAssigned ?? 0));
      if (profileData.Data.Records.ZoneList) {
        setZones(profileData.Data.Records.ZoneList)
      }
      if (profileData.Data.Records.AllowedVehicleTypes) {
        setAllowedVehicleTypes(profileData.Data.Records.AllowedVehicleTypes)
      }
      if (profileData.Data.Records.AllowedFuelTypes) {
        setAllowedFuelTypes(profileData.Data.Records.AllowedFuelTypes)
      }
      if (profileData.Data.Records.AllowedAccessibleTypes) {
        setAllowedAccessibleTypes(profileData.Data.Records.AllowedAccessibleTypes)
      }
      if (profileData.Data.Records.AllowedShareableTypes) {
        setAllowedShareableTypes(profileData.Data.Records.AllowedShareableTypes)
      }
    } catch (err) {
      setError(err.message);
    } finally {
      // Only clear the loader when this fetch owns it. Silent refreshes during a
      // save must not turn off the loader the save flow is showing.
      if (!isSilent) setIsLoading(false);
    }
  };

  // const fetchZonesForGroup = async (groupId) => {
  //   try {
  //     const response = await fetchWithTokenRefresh2(BASE_URL + EditProfile_api, {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({
  //         GroupId: groupId,
  //         FirstName: formData.firstName,
  //         LastName: formData.lastName,
  //         AppVersion: App_version,
  //         Language: "english",
  //         DeviceId: DeviceId,
  //         OsVersion: OsVersion,
  //         GuId: getGuId(),
  //         DefaultZoneId: selectedZoneId,
  //         ManufactureModel: ManufactureModel,
  //       })
  //     });
  //     const data = await response.json();
  //     if (data?.Data?.ResponseCode === 200) {
  //       await fetchData();
  //     }
  //     if (data?.Data?.Records?.ZoneList) {
  //       console.log("HERERER", data.Data.Records.ZoneList)
  //       setZones(data.Data.Records?.ZoneList);
  //       setSelectedZoneId(data.Data.Records?.ZoneList[0]?.Id || null);

  //       await fetchData()
  //     }
  //   } catch (err) {
  //     setError('Failed to fetch zones for group: ' + err.message);
  //   }
  // };

  const fetchZonesForGroup = async (groupId) => {
    try {
      const response = await fetchWithTokenRefresh2(BASE_URL + GroupZoneList_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          GroupId: groupId,
          AppVersion: "12.15.2",
          GuId: getGuId(),
          Language: "english",
          ManufactureModel: "Android SDK built for x86",
          DeviceId: "c90d1fa3-e837-46e7-a5e2-15a9ad5ce21d",
          OsVersion: "11",
        })
      });

      const data = await response.json();
      const records = data?.Data?.Records;

      if (records?.ZoneList) {
        setZones(records.ZoneList);

        // FIX: Ensure the ID is a Number to match your state logic
        const defaultId = records.ZoneId || records.ZoneList[0]?.Id;
        if (defaultId) {
          setSelectedZoneId(parseInt(defaultId));
        }
      }
    } catch (err) {
      setError(err.message);
    }
  };


  // const handleDeleteVehicle = async (vehicleId, FuelId, RegistrationName, TypeId, ShareableId, AccessibleId) => {
  //   if (!window.confirm("Are you sure you want to remove this vehicle?")) return;
  //   setIsLoading(true);
  //   const deleteData = {
  //     Action: "Delete",
  //     GuId: getGuId(),
  //     Language: "english",
  //     DeviceId: DeviceId,
  //     OsVersion: OsVersion,
  //     ManufactureModel: ManufactureModel,
  //     AppVersion: App_version,
  //     VehicleId: vehicleId.toString(),
  //     VehicleFuelId: FuelId,
  //     VehicleNumber: RegistrationName,
  //     VehicleSizeId: TypeId,
  //     VehicleShareableId: ShareableId,
  //     VehicleAccessibleId: AccessibleId
  //   };
  //   try {
  //     const response = await fetchWithTokenRefresh2(BASE_URL + VehicleRegistration_api, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(deleteData),
  //     });
  //     const responseData = await response.json();
  //     // const Toast = CustomSuccessToast(responseData)
  //     handleApiResponse(responseData, setNotification, t, {
  //       successMsg: 1,
  //       errorMsg: 1
  //     });
  //     if (responseData?.Data?.ResponseCode === 200) {
  //       await fetchData(); // Refresh UI with latest vehicles
  //     } else {
  //       setError(responseData?.Data?.ErrorMessage || "Deletion failed");
  //     }
  //   } catch (err) {
  //     setError(err.message);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };


  const confirmDeleteVehicle = async () => {
    if (!vehicleToDelete) return;

    setIsLoading(true);
    setDeletePopupVisible(false);


    const deleteData = {
      Action: "Delete",
      GuId: getGuId(),
      Language: "english",
      DeviceId,
      OsVersion,
      ManufactureModel,
      AppVersion: App_version,
      VehicleId: vehicleToDelete.Id.toString(),
      VehicleFuelId: vehicleToDelete.FuelId,
      VehicleNumber: vehicleToDelete.RegistrationName,
      VehicleSizeId: vehicleToDelete.TypeId,
      VehicleShareableId: vehicleToDelete.ShareableId,
      VehicleAccessibleId: vehicleToDelete.AccessibleId
    };

    try {
      const response = await fetchWithTokenRefresh2(
        BASE_URL + VehicleRegistration_api,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(deleteData),
        }
      );

      const responseData = await response.json();

      // const isOk = handleApiResponse(responseData, setNotification, t, {
      //   successMsg: 1,
      //   errorMsg: 1
      // });
      const isOk = handleApiUiResponse(response, {
        successToaster: 1,
        errorToaster: 1,
        alertPopup: 1
      });

      if (responseData?.Data?.ResponseCode === 200) {
        await fetchData();
        setDeletePopupVisible(false);
        setVehicleToDelete(null);
      }

    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setValidationError("");
    setNewVehicles([]);
    setVehicleAdded(false)
    setOpenNewFuelDraftIndex(null);
    setOpenNewAccessibleDraftIndex(null);
    setOpenNewShareableDraftIndex(null);
    setIsOpenFnew(false);

    setShowPopup(false);
  };

  // This holds the "Last Saved" version of your data
  const [originalData, setOriginalData] = useState({
    firstName: "",
    lastName: "",
    vehicles: [],
    selectedZoneId: null,
    selectedGroupId: null
  });

  const updateProfile = async (vehicleGuIds = "") => {
    const updatedData = {
      FirstName: formData.firstName,
      LastName: formData.lastName,
      AppVersion: "12.15.0",
      Language: "english",
      DeviceId: DeviceId,
      OsVersion: OsVersion,
      GuId: getGuId(),
      ManufactureModel: ManufactureModel,
    };

    // Group / default zone are only hydrated when the profile API returns
    // `Groups`. Posting them as null on a vehicle-only save would clear the
    // user's default zone, so they are only sent once we actually have a value.
    if (selectedZoneId !== null && selectedZoneId !== undefined) {
      updatedData.DefaultZoneId = selectedZoneId;
    }
    if (selectedGroupId !== null && selectedGroupId !== undefined) {
      updatedData.GroupId = selectedGroupId;
    }

    // Drag-to-reorder: the vehicle GuIds in display order, comma separated, so
    // the profile screen reopens with the order the user left behind.
    if (vehicleGuIds) {
      updatedData.VehicleGuIds = vehicleGuIds;
    }

    const response = await fetchWithTokenRefresh2(BASE_URL + EditProfile_api, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(updatedData),
    });

    return await response.json();
  };
  const addVehicle = async () => {
    const vehiclesToAdd = newVehicles
      .filter((vehicle) => vehicle.VehicleNumber?.trim())
      .map((vehicle) => ({
        VehicleNumber: vehicle.VehicleNumber.trim(),
        VehicleSizeId: String(vehicle.VehicleSizeId || ""),
        VehicleFuelId: String(vehicle.VehicleFuelId || ""),
        VehicleAccessibleId: String(vehicle.VehicleAccessibleId ?? 0),
        VehicleShareableId: String(vehicle.VehicleShareableId ?? 0),
      }));

    if (vehiclesToAdd.length === 0) {
      return null;
    }

    const updatedData = {
      GuId: getGuId(),
      Action: "Add",
      Language: "english",
      DeviceId: DeviceId,
      OsVersion: OsVersion,
      ManufactureModel: ManufactureModel,
      AppVersion: App_version,
      Vehicles: vehiclesToAdd,
    }

    const response = await fetchWithTokenRefresh2(BASE_URL + VehicleRegistrationBulkAdd_API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedData),
    });
    const data = await response.json();

    if (data?.Data?.ResponseCode === 200) {
      await fetchData(true); // Silent refresh — keep the save loader continuous
      setShowPopup(false);
      setNewVehicles([]);
      setAddSizePopupVisible(null);
      setVehicleAdded(false); // Reset flag immediately after add
    }

    return data;
  };


  // The fields VehicleRegistration_api actually persists, compared against the
  // last list the profile API returned (vehiclesRef), so an untouched card is
  // never posted.
  const hasVehicleChanged = (vehicle) => {
    const original = vehiclesRef.current?.find((v) => v.Id === vehicle.Id);
    // No baseline for this Id - treat it as changed so an edit is never dropped.
    if (!original) return true;

    return (
      String(original.RegistrationName ?? "") !== String(vehicle.RegistrationName ?? "") ||
      String(original.TypeId ?? "") !== String(vehicle.TypeId ?? "") ||
      String(original.FuelId ?? "") !== String(vehicle.FuelId ?? "") ||
      String(original.ShareableId ?? "") !== String(vehicle.ShareableId ?? "") ||
      String(original.AccessibleId ?? "") !== String(vehicle.AccessibleId ?? "")
    );
  };

  // A backend failure returns an HTML error page, not JSON. res.json() throws on
  // that and would take the whole save into the catch block, so it is reported as
  // an ordinary failed response instead.
  const parseVehicleResponse = async (response) => {
    try {
      return await response.json();
    } catch {
      return { Data: { ResponseCode: 500, ErrorMessage: "" } };
    }
  };

  // Vehicles are updated one at a time, never in parallel. Each request loads a
  // large model chain on the backend and opens its own DB connection, so firing
  // N of them together exhausted the connection pool ("Too many connections",
  // HY000/1040) and the refused requests came back as HTML, so those vehicles
  // silently skipped their update. Only cards that actually differ from the last
  // profile response are sent, so editing one card in a list of eight is one
  // request, not eight.
  const updateVehicles = async () => {
    const changedVehicles = vehicles.filter(hasVehicleChanged);

    // Nothing to persist (e.g. a field was typed and put back). A synthetic 200
    // keeps the save flow's toaster behaviour unchanged.
    if (changedVehicles.length === 0) {
      return { Data: { ResponseCode: 200 } };
    }

    let lastResult = null;

    for (const vehicle of changedVehicles) {
      const payload = {
        Action: "Edit",
        VehicleId: vehicle.Id.toString(),
        VehicleNumber: vehicle.RegistrationName,
        VehicleSizeId: vehicle.TypeId.toString(),
        VehicleFuelId: vehicle.FuelId.toString(),
        VehicleShareableId: vehicle.ShareableId.toString(),
        VehicleAccessibleId: vehicle.AccessibleId.toString(),
        GuId: getGuId(),
        Language: "english",
        DeviceId: DeviceId,
        OsVersion: OsVersion,
        ManufactureModel: ManufactureModel,
        AppVersion: App_version,
      };

      // await inside the loop is deliberate: the next vehicle must not start
      // until this one has come back.
      // eslint-disable-next-line no-await-in-loop
      const response = await fetchWithTokenRefresh2(BASE_URL + VehicleRegistration_api, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      // eslint-disable-next-line no-await-in-loop
      lastResult = await parseVehicleResponse(response);

      // Stop on the first failure rather than piling more load onto a backend
      // that has already refused one request, and surface that failure to the
      // toaster instead of a later success.
      if (Number(lastResult?.Data?.ResponseCode) !== 200) {
        return lastResult;
      }
    }

    return lastResult;
  };

  // const handleSaveAll = async (e) => {
  //   if (e) e.preventDefault();

  //   setIsLoading(true);
  //   setShowPopup(false);

  //   const shouldAddVehicle = vehicleAdded;
  //   const shouldUpdateVehicle = vehicleUpdated;
  //   const shouldUpdateProfile = profileChanged;

  //   if (!shouldAddVehicle && !shouldUpdateVehicle && !shouldUpdateProfile) {
  //     setIsLoading(false);
  //     return;
  //   }

  //   try {
  //     let lastResponse = null;

  //     if (shouldAddVehicle) {
  //       console.log("Adding vehicle...");
  //       lastResponse = await addVehicle();
  //       // Always refresh vehicles after add
  //       await fetchData();
  //     }

  //     if (shouldUpdateVehicle) {
  //       console.log("Updating vehicles...");
  //       lastResponse = await updateVehicles();
  //       await fetchData();
  //     }

  //     if (shouldUpdateProfile) {
  //       console.log("Updating profile...");
  //       lastResponse = await updateProfile();
  //       await fetchProfile();
  //     }

  //     const isOk = CustomSuccessToast(lastResponse);

  //     // reset flags AFTER success
  //     setVehicleAdded(false);
  //     setVehicleUpdated(false);
  //     setProfileChanged(false);

  //   } catch (err) {
  //     console.error(err);
  //     alert("Something went wrong");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  const handleSaveAll1 = async (e) => {
    if (e) e.preventDefault();
    setShowPopup(false);

    // 1. Identify what needs updating
    const shouldAddVehicle = vehicleAdded && newVehicles.some((vehicle) => vehicle.VehicleNumber?.trim());
    const shouldUpdateVehicle = vehicleUpdated;
    const shouldUpdateProfile = profileChanged;
    const shouldUpdatePassword = passwords.new.length > 0;

    const shouldUpdateCalendar = calendarChanged;
    const handleNotificationsToggle = pushChanged;
    const handleNotificationsEmail = emailChanged;

    // 2. Validation Gate
    if (shouldUpdatePassword && !isFormValid) {
      toast.error("Please complete the password requirements.");
      return;
    }

    // 3. Exit if absolutely nothing changed
    if (
      !shouldAddVehicle &&
      !shouldUpdateVehicle &&
      !shouldUpdateProfile &&
      !shouldUpdatePassword &&

      !shouldUpdateCalendar &&
      !handleNotificationsToggle &&
      !handleNotificationsEmail) {
      return;
    }

    setIsLoading(true);
    try {
      let lastResponse = null;

      // --- Action: Calendar Sync (New) ---
      // if (shouldUpdateCalendar) {
      //   console.log("Updating Calendar Setting...");
      //   const calResponse = await fetchWithTokenRefresh2(BASE_URL + ToggleSyncBookingToggle_API, {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //       Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      //     },
      //     body: JSON.stringify({
      //       GuId: localStorage.getItem("guId"),
      //       Language: getSessionLanguageCode(),
      //       DeviceId: DeviceId,
      //       OsVersion: OsVersion,
      //       ManufactureModel: ManufactureModel,
      //       AppVersion: App_version,
      //       Status: SyncCalendarStatus ? "1" : "0" // Uses the current UI state
      //     }),
      //   });
      //   lastResponse = await calResponse.json();
      // }

      // --- Action 1: Add Vehicle ---
      if (shouldAddVehicle) {
        lastResponse = await addVehicle();
        await fetchData();
      }

      // --- Action 2: Update Existing Vehicles ---
      if (shouldUpdateVehicle) {
        lastResponse = await updateVehicles();
        await fetchData();
      }

      // --- Action 3: Update Profile Info ---
      if (shouldUpdateProfile) {
        lastResponse = await updateProfile();
        await fetchProfile();
      }

      // --- Action 4: Change Password ---
      if (shouldUpdatePassword) {
        console.log("Changing password...");
        const passwordPayload = {
          GuId: localStorage.getItem("guId"),
          OldPasswordT: CryptoJS.MD5(passwords.old).toString(),
          PasswordT: CryptoJS.MD5(passwords.new).toString(),
          PasswordN: CryptoJS.SHA512(passwords.confirm).toString(),
          AppVersion: App_version,
          DeviceId: DeviceId,
          OsVersion: OsVersion,
          ManufactureModel: ManufactureModel,
          Language: "english"
        };

        const pswResponse = await fetchWithTokenRefresh2(BASE_URL + ChangePassword_API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(passwordPayload)
        });

        lastResponse = await pswResponse.json();
      }

      // --- Action:5 Push Notifications ---
      if (handleNotificationsToggle) {
        lastResponse = await updatePushStatus();
        if (lastResponse?.Data?.ResponseCode === 200) {
          localStorage.setItem("ReminderNotifications", notificationsEnabled ? "1" : "0");
        }
      }

      // --- Action:6 Email Notifications ---
      if (handleNotificationsEmail) {
        lastResponse = await updateEmailStatus();
      }

      // --- Action:7 Calendar Sync ---
      if (shouldUpdateCalendar) {
        lastResponse = await updateCalendarSettings();
      }

      // --- Action: Vehicles & Profile ---
      if (shouldAddVehicle) { lastResponse = await addVehicle(); await fetchData(); }
      if (vehicleUpdated) { lastResponse = await updateVehicles(); await fetchData(); }
      if (profileChanged) { lastResponse = await updateProfile(); await fetchProfile(); }

      // 4. Trigger the Custom Toaster
      // const isOk = CustomSuccessToast(lastResponse);
      // const isOk = handleApiResponse(lastResponse, setNotification, t, {
      //   successMsg: 1,
      //   errorMsg: 1
      // });

      const isOk = handleApiUiResponse(lastResponse, {
        successToaster: 1,
        errorToaster: 1,
        alertPopup: 1
      });

      if (isOk) {
        // 5. Reset ALL change flags
        setCalendarChanged(false); // Reset the toggle flag
        setVehicleAdded(false);
        setVehicleUpdated(false);
        setProfileChanged(false);
        setPushChanged(false)
        setEmailChanged(false)
        setPasswords({ old: '', new: '', confirm: '' });

        // Update baseline
        setOriginalData({
          profile: {
            ...formData,
            syncCalendar: SyncCalendarStatus // Save state to baseline
          },
          vehicles: [...vehicles]
        });
      }

    } catch (err) {
      console.error("Critical Save Error:", err);
      toast.error("An internal error occurred.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveAll = async (e) => {
    if (e) e.preventDefault();

    setOpenFuelVehicleId(null);
    setOpenAccessibleVehicleId(null);
    setOpenShareableVehicleId(null);

    setOpenNewFuelDraftIndex(null);
    setOpenNewAccessibleDraftIndex(null);
    setOpenNewShareableDraftIndex(null);
    cancelVehicleDrag();
    // setpopupVehicleNumber("");
    // setPopupAllowedVehicleTypes("");
    // setPopupAllowedFuelTypes("");
    // setValidationError("");
    // setIsLoading(true);

    // setShowPopup(false);

    // Card order + drafts as they are on screen right now. Captured before any
    // request runs because bulk-add refreshes the profile mid-save, which resets
    // both `vehicles` and `newVehicles`.
    const vehicleOrderSnapshot = getVehicleOrderSnapshot();
    const draftsAtSave = newVehicles;

    // 1. Identify what needs updating
    const shouldAddVehicle = vehicleAdded;
    const shouldUpdateVehicle = vehicleUpdated;
    const shouldUpdateProfile = profileChanged;
    const shouldSaveVehicleOrder = vehicleOrderChanged;
    const shouldUpdatePassword = passwords.new.length > 0;
    const shouldUpdateCalendar = calendarChanged;
    const shouldUpdatePush = pushChanged;
    const shouldUpdateEmail = emailChanged;
    const shouldUpdateLanguage = languageChanged && !!pendingLanguage;

    // 2. Validation Gate
    if (shouldUpdatePassword && !isFormValid) {
      toast.error("Please complete the password requirements.");
      return;
    }

    // Vehicle empty-field validation (existing vehicles + new drafts)
    const existingVehicleErrors = {};
    if (shouldUpdateVehicle) {
      vehicles.forEach((v) => {
        if (!v.RegistrationName || v.RegistrationName.trim() === "") {
          existingVehicleErrors[v.Id] = "error";
        }
      });
    }
    const draftVehicleErrors = {};
    if (shouldAddVehicle) {
      newVehicles.forEach((d, index) => {
        if (!d.VehicleNumber || d.VehicleNumber.trim() === "") {
          draftVehicleErrors[index] = "error";
        }
      });
    }
    if (Object.keys(existingVehicleErrors).length > 0 || Object.keys(draftVehicleErrors).length > 0) {
      setVehicleFieldStatus({ existing: existingVehicleErrors, drafts: draftVehicleErrors });
      const firstExistingId = Object.keys(existingVehicleErrors)[0];
      const firstDraftIndex = Object.keys(draftVehicleErrors)[0];
      setTimeout(() => {
        const target = firstExistingId
          ? document.getElementById(`registrationName-${firstExistingId}`)
          : document.getElementById(`vehicle-draft-${firstDraftIndex}`);
        if (target) {
          target.focus();
          target.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 100);
      return; // block save until the vehicle field is filled
    }

    // 3. Exit if absolutely nothing changed
    if (
      !shouldAddVehicle && !shouldUpdateVehicle && !shouldUpdateProfile &&
      !shouldSaveVehicleOrder && !shouldUpdatePassword && !shouldUpdateCalendar &&
      !shouldUpdatePush && !shouldUpdateEmail && !shouldUpdateLanguage
    ) {
      return;
    }

    setIsLoading(true);

    // setIsLoading(true);
    try {
      setValidationError("");
      let lastResponse = null;

      // --- Action 1: Add Vehicle (ONLY ONCE) ---
      if (shouldAddVehicle) {
        lastResponse = await addVehicle();
        // await fetchData(); // Refresh vehicle list
      }

      // --- Action 2: Update Existing Vehicles (ONLY ONCE) ---
      if (shouldUpdateVehicle) {
        lastResponse = await updateVehicles();
        // await fetchData();
      }

      // --- Action 3: Update Profile Info (Includes Group/Zone + vehicle order) ---
      // Runs after add/edit so a draft that was dragged into position resolves to
      // the GuId the bulk-add just created.
      if (shouldUpdateProfile || shouldSaveVehicleOrder) {
        const orderedVehicleGuIds = buildOrderedVehicleGuIds({
          orderSnapshot: vehicleOrderSnapshot,
          drafts: draftsAtSave,
          serverVehicles: vehiclesRef.current,
        });
        lastResponse = await updateProfile(orderedVehicleGuIds);
        // Armed before the closing refresh so the incoming list is adopted as-is:
        // a saved draft has to leave its draft slot and take up its persisted
        // position. A failed call keeps the flag so the order can be retried.
        if (lastResponse?.Data?.ResponseCode === 200) {
          resetVehicleOrderChanged({ adoptServerOrder: true });
        }
        // await fetchData();
      }

      // --- Action 4: Change Password ---
      if (shouldUpdatePassword) {

        const passwordPayload = {
          GuId: localStorage.getItem("guId"),
          OldPasswordT: CryptoJS.MD5(passwords.old).toString(),
          PasswordT: CryptoJS.MD5(passwords.new).toString(),
          PasswordN: CryptoJS.SHA512(passwords.confirm).toString(),
          AppVersion: App_version,
          DeviceId: DeviceId,
          OsVersion: OsVersion,
          ManufactureModel: ManufactureModel,
          Language: getSessionLanguageCode()
        };

        const pswResponse = await fetchWithTokenRefresh2(BASE_URL + ChangePassword_API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(passwordPayload)
        });
        lastResponse = await pswResponse.json();
        if (lastResponse?.Data?.ResponseCode === 200 || lastResponse?.Success) {
          setPasswords({
            old: '',
            new: '',
            confirm: ''
          });
        }
      }

      // --- Action 5: Push Notifications ---
      if (shouldUpdatePush) {
        lastResponse = await updatePushStatus();
        if (lastResponse?.Data?.ResponseCode === 200) {
          localStorage.setItem("ReminderNotifications", notificationsEnabled ? "1" : "0");
          // Only set if you still want to use sessionStorage, 
          // otherwise use localStorage.removeItem("Notifications") as discussed
        }
      }

      // --- Action 6: Email Notifications ---
      if (shouldUpdateEmail) {
        lastResponse = await updateEmailStatus();
      }

      // --- Action 7: Calendar Sync ---
      if (shouldUpdateCalendar) {
        lastResponse = await updateCalendarSettings();
      }

      // --- Action 8: Language (client-side; applied live via react-i18next) ---
      // No reload: i18n.changeLanguage updates every t() reactively and
      // setLanguage persists the code for API calls.
      if (shouldUpdateLanguage) {
        setLanguage(JSON.stringify(pendingLanguage));
        i18n.changeLanguage(pendingLanguage.code);
        setLanguageChanged(false);
        // A language-only change has no API response — provide a synthetic 200
        // so the success toaster still shows.
        if (!lastResponse) {
          lastResponse = { Data: { ResponseCode: 200 } };
        }
      }

      await fetchData(true);
      // 4. Trigger the Custom Toaster
      // const isOk = CustomSuccessToast(lastResponse);
      // const isOk = handleApiResponse(lastResponse, setNotification, t, {
      //   successMsg: 1,
      //   errorMsg: 1
      // });

      handleApiUiResponse(lastResponse, {
        successToaster: 1,
        errorToaster: 1,
        alertPopup: 1
      });

      // handleApiUiResponse renders the toaster/popup but returns nothing, so
      // success has to be read from the response itself. While this was taken
      // from its return value it was always undefined, the reset block below
      // never ran, and vehicleUpdated stayed true for the rest of the session,
      // re-posting every vehicle on every later save.
      const isOk = Number(lastResponse?.Data?.ResponseCode) === 200;

      if (isOk) {
        // 5. Reset ALL change flags
        setCalendarChanged(false);
        setVehicleAdded(false);
        setVehicleUpdated(false);
        setProfileChanged(false);
        setPushChanged(false);
        setEmailChanged(false);
        setPasswords({ old: '', new: '', confirm: '' });

        // 6. Update baseline (originalData) so "Discard" knows the new state
        setOriginalData({
          firstName: formData.firstName,
          lastName: formData.lastName,
          primaryEmail: formData.PrimaryEmail,
          emailNotification: emailNotification,
          syncCalendar: SyncCalendarStatus,
          pushNotification: notificationsEnabled,
          groupId: selectedGroupId,      // Added for Dropdown reset
          groupName: selectedGroupName,  // Added for Dropdown reset
          zoneId: selectedZoneId,        // Added for Dropdown reset
          zoneName: selectedZoneName,    // Added for Dropdown reset
          vehicles: [...vehicles],
          groups: [...groups]
        });
      }

    } catch (err) {
      console.error("Critical Save Error:", err);
      toast.error("An internal error occurred.");
    } finally {
      setIsLoading(false);
    }
  };
  // const handleSaveAll = async (e) => {
  //   if (e) e.preventDefault();
  //   setShowPopup(false)

  //   // 1. Identify what needs updating
  //   const shouldAddVehicle = vehicleAdded;
  //   const shouldUpdateVehicle = vehicleUpdated;
  //   const shouldUpdateProfile = profileChanged;

  //   // Logic: User wants to change password if they've typed anything in 'new password'
  //   const shouldUpdatePassword = passwords.new.length > 0;

  //   // 2. Validation Gate: If they are trying to change password, validate it first
  //   if (shouldUpdatePassword && !isFormValid) {
  //     toast.error("Please complete the password requirements.");
  //     return;
  //   }

  //   // 3. Exit if nothing changed
  //   if (!shouldAddVehicle && !shouldUpdateVehicle && !shouldUpdateProfile && !shouldUpdatePassword) {
  //     return;
  //   }

  //   setIsLoading(true);
  //   try {
  //     let lastResponse = null;

  //     // --- Action 1: Add Vehicle ---
  //     if (shouldAddVehicle) {
  //       console.log("Adding vehicle...");
  //       lastResponse = await addVehicle();
  //       await fetchData(); // Refresh list
  //     }

  //     // --- Action 2: Update Existing Vehicles ---
  //     if (shouldUpdateVehicle) {
  //       console.log("Updating vehicles...");
  //       lastResponse = await updateVehicles();
  //       await fetchData();
  //     }

  //     // --- Action 3: Update Profile Info ---
  //     if (shouldUpdateProfile) {
  //       console.log("Updating profile...");
  //       lastResponse = await updateProfile();
  //       await fetchProfile();
  //     }

  //     // --- Action 4: Change Password ---
  //     if (shouldUpdatePassword) {
  //       console.log("Changing password...");
  //       const passwordPayload = {
  //         GuId: localStorage.getItem("guId"),
  //         OldPasswordT: CryptoJS.MD5(passwords.old).toString(),
  //         PasswordT: CryptoJS.MD5(passwords.new).toString(),
  //         PasswordN: CryptoJS.SHA512(passwords.confirm).toString(),
  //         AppVersion: App_version,
  //         DeviceId: DeviceId,
  //         OsVersion: OsVersion,
  //         ManufactureModel: ManufactureModel,
  //         Language: "english"
  //       };

  //       const pswResponse = await fetchWithTokenRefresh2(BASE_URL + ChangePassword_API, {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(passwordPayload)
  //       });

  //       lastResponse = await pswResponse.json();
  //     }

  //     // 4. Trigger the Custom Toaster with the result of the LAST operation
  //     const isOk = CustomSuccessToast(lastResponse);

  //     if (isOk) {
  //       // 5. Reset all change flags and clear password fields
  //       setVehicleAdded(false);
  //       setVehicleUpdated(false);
  //       setProfileChanged(false);
  //       setPasswords({ old: '', new: '', confirm: '' });

  //       // Update our 'OriginalData' baseline so Cancel works correctly for future edits
  //       setOriginalData({
  //         profile: {
  //           firstName: formData.firstName, lastName: formData.lastName,
  //           PrimaryEmail: formData.PrimaryEmail,
  //           allowedVehicleTypes: formData.allowedVehicleTypes,
  //           remindEmail: formData.remindEmail,
  //           remindNotification: formData.remindNotification,
  //           RegistrationName: formData.RegistrationName
  //         },
  //         vehicles: [...vehicles]
  //       });
  //     }

  //   } catch (err) {
  //     console.error("Critical Save Error:", err);
  //     toast.error("An internal error occurred.");
  //   } finally {
  //     setIsLoading(false);
  //     setShowPopup(false);
  //   }
  // };


  // const discardAll = async (e) => {
  //   setNotificationsEnabled(false);
  //   setEmailNotification(false);
  //   setSyncCalendarStatus(false)
  // }
  const discardAllAPI = async () => {
    try {
      // Always fetch the latest profile from the server
      const latestProfile = await fetchProfile();
      hydrateProfileFromRecords(latestProfile?.Data?.Records || {});
      setProfile(latestProfile);
      // Reset profile fields
      setFormData({
        firstName: latestProfile?.Data?.Records?.FirstName || "",
        lastName: latestProfile?.Data?.Records?.LastName || "",
        PrimaryEmail: latestProfile?.Data?.Records?.PrimaryEmail || "",
        allowedVehicleTypes:
          latestProfile?.Data?.Records?.AllowedVehicleTypes?.map((vehicle) => vehicle.Name) || [],
      });
      // Reset vehicles
      setVehicles(latestProfile?.Data?.Records?.Vehicles || []);
      setGroups(latestProfile?.Data?.Records?.Groups || [])
      // Reset add vehicle popup fields
      setNewVehicles([]);
      setAddSizePopupVisible(null);
      setShowPopup(false);
      // Reset password fields (using setPasswords state)
      setPasswords({ old: '', new: '', confirm: '' });
      // Reset change flags
      setProfileChanged(false);
      setVehicleAdded(false);
      setVehicleUpdated(false);
      setValidationError("");
      setVehicleFieldStatus({ existing: {}, drafts: {} });
      setError(null);
    } catch (err) {
      setError("Failed to discard changes: " + err.message);
    }
  };

  //   const discardAll = () => {
  //   if (!originalDataforlocal) return;

  //   // 1. Reset Profile Info
  //   setFormData({
  //     firstName: originalDataforlocal.firstName,
  //     lastName: originalDataforlocal.lastName,
  //     PrimaryEmail: originalDataforlocal.primaryEmail,
  //     allowedVehicleTypes: originalDataforlocal.vehicles.map((v) => v.Name) || [],
  //   });

  //   // 2. Reset Toggles Instantly
  //   setEmailNotification(originalDataforlocal.emailNotification);
  //   setSyncCalendarStatus(originalDataforlocal.syncCalendar);
  //   setNotificationsEnabled(originalDataforlocal.pushNotification);

  //   // 3. Reset Lists
  //   setVehicles([...originalDataforlocal.vehicles]);

  //   setSelectedGroupId(originalDataforlocal.GroupId)
  //   setGroups([...originalDataforlocal.groups]);

  //   // 4. Clear Temporary UI States
  //   setPasswords({ old: '', new: '', confirm: '' });
  //   setpopupVehicleNumber("");
  //   setShowPopup(false);

  //   // 5. Reset ALL Change Flags (This turns the Save button gray)
  //   setProfileChanged(false);
  //   setVehicleAdded(false);
  //   setVehicleUpdated(false);
  //   setCalendarChanged(false); 
  //   setPushChanged(false);     
  //   setEmailChanged(false);

  //   toast.success("Changes reverted to original");
  // };


  const discardAll = () => {
    window.location.reload();
  };
  const [loading, setLoading] = useState(false);
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [passwords, setPasswords] = useState({
    old: '',
    new: '',
    confirm: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPasswords(prev => ({ ...prev, [name]: value }));
  };

  // const validations = {
  //   // complexity: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?]).{10,}$/.test(passwords.new),
  //   complexity: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?]).*$/.test(passwords.new),
  //   match: passwords.new === passwords.confirm && passwords.confirm !== ''
  // };

  // const isFormValid = validations.complexity && validations.match && passwords.old !== '';

  const validations = {
    complexity: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?])[^\s]*$/.test(passwords.new),
    isMinLength: passwords.new.length >= 8,
    // Check for spaces in all fields
    oldHasSpace: /\s/.test(passwords.old),
    newHasSpace: /\s/.test(passwords.new),
    confirmHasSpace: /\s/.test(passwords.confirm),
    match: passwords.new === passwords.confirm && passwords.confirm !== ''
  };

  const spacevalidations = {
    complexity: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?])[^\s]*$/.test(passwords.new),
    oldHasSpace: /\s/.test(passwords.old),
  };

  const isFormValid =
    validations.complexity &&
    validations.isMinLength &&
    !validations.oldHasSpace &&
    !validations.newHasSpace &&
    !validations.confirmHasSpace &&
    validations.match &&
    passwords.old !== '';

  const GuId = localStorage.getItem("guId")

  const handleSave = async () => {
    if (!isFormValid) return;

    setLoading(true);
    try {
      const payload = {
        GuId: GuId,
        OldPasswordT: CryptoJS.MD5(passwords.old).toString(),
        PasswordT: CryptoJS.MD5(passwords.new).toString(),
        PasswordN: CryptoJS.SHA512(passwords.confirm).toString(),
        AppVersion: App_version,
        DeviceId: DeviceId,
        OsVersion: OsVersion,
        ManufactureModel: ManufactureModel,
        Language: "english"
      };

      const response = await fetchWithTokenRefresh2(BASE_URL + ChangePassword_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const responseData = await response.json();

      // 1. Call your CustomSuccessToast function
      // This will trigger the custom UI toast for success or default toast for errors
      // const isOk = CustomSuccessToast(responseData);
      // const isOk = handleApiResponse(responseData, setNotification, t, {
      //   successMsg: 1,
      //   errorMsg: 1
      // });

      const isOk = handleApiUiResponse(response, {
        successToaster: 1,
        errorToaster: 1,
        alertPopup: 1
      });

      if (isOk) {
        // 2. Clear the form ONLY if the response code was 200
        setPasswords({ old: '', new: '', confirm: '' });
      }
    } catch (error) {
      console.error("Submission Error:", error);
      toast.error("An internal error occurred.");
    } finally {
      setLoading(false);
    }
  };

  const headerTitle = t("react_hi").replace("%s", userName);

  return (
    <div>
      <div className={`content-area ${isDeleteAccountEntryFlow ? "delete-account-entry-flow" : ""}`}>
        {/* <HeaderNoDropdown /> */}
        <header className="header">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-3">
                <div className="greeting-title">
                  <p>{headerTitle}</p>
                </div>
              </div>

              <div className="col-md-6">
              </div>

              <div className="col-md-3">
                <div className="menu-bar-options d-flex justify-content-end gap-3">
                  {Number(zoneCreditValue) !== 0 && (
                    <CreditInfoCard
                      userZoneCreditValue={zoneCreditValue}
                      userZoneCreditBalance={creditBalance}
                      creditBalanceRefillEvery={creditBalanceRefillEvery}
                      IsThumbnailPresent={isThumbnailPresent}
                      CompanyId={companyId}
                    />
                  )}
                  <div className="notification-info">
                    <a href="#" data-bs-toggle="offcanvas" data-bs-target="#notification-panel" aria-controls="notification-panel" className="position-relative notification-icon">
                      <img src={Notification} alt="" />
                      {hasUnreadNotifications && (
                        <span className="orange-dot"></span>
                      )}</a>
                  </div>
                  <NotificationPanel
                    onUnreadChange={setHasUnreadNotifications}
                    onNotificationToggleChange={syncNotificationsToggleFromPanel}
                  />

                </div>
              </div>
            </div>
          </div>
        </header>
        {/* <IFrame/> */}
        <div className="component-area profile-setting-page">
          {isLoading && (
            <div id='preloader'>

              <img src={loadingGIF} alt="" />
            </div>
          )}
          <Sidebar
            IsThumbnailPresent={isThumbnailPresent}
            CompanyId={companyId}
          />
          <div className="pt-96 my-container active-cont">
            <div className="container">
              <div className="row mt-md-4 mt-85">
                <div className="col-xl-8 offset-xl-2">
                  <div className="setting-options">
                    <ul className="nav nav-tabs position-relative" ref={tabContainerRef} id="myTab" role="tablist">
                      <li className="nav-item" role="presentation">
                        <button
                          className={`nav-link ${activeTab === "profile-setting" ? "active" : ""}`}
                          onClick={() => setActiveTab("profile-setting")}
                          type="button"
                          role="tab"
                        >
                          {t("react_profile")}
                        </button>
                      </li>
                      {parkingZonesAssigned === 1 && (
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link ${activeTab === "vehicle-setting" ? "active" : ""}`}
                            onClick={() => setActiveTab("vehicle-setting")}
                            type="button"
                            role="tab"
                          >
                            {t("vehicle")}
                          </button>
                        </li>
                      )}
                      {!isSSOLogin && !isTeamsSession && (
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link ${activeTab === "password-setting" ? "active" : ""}`}
                            onClick={() => setActiveTab("password-setting")}
                            type="button"
                            role="tab"
                          >
                            {t("password")}
                          </button>
                        </li>
                      )}

                      <li className="nav-item" role="presentation">
                        <button
                          className={`nav-link ${activeTab === "help-setting" ? "active" : ""}`}
                          onClick={() => setActiveTab("help-setting")}
                          type="button"
                          role="tab"
                        >
                          {t("need_help")}
                        </button>
                      </li>

                    </ul>

                    <div className="tab-content" id="myTabContent">
                      <div className={`tab-pane fade ${activeTab === "profile-setting" ? "show active" : ""}`}>
                        <form action="#" className="form-elements mt-5">
                          <div className="setting-form-details">
                            <div className="height-wrapper">
                              <div className="row g-4">
                                <div className="col-md-6">
                                  {/* <div className="form-group"> */}
                                  <label htmlFor="fname">{t("firstName")}*</label>
                                  <input type="text" className="form-control"
                                    id="fname"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleInputChangeProfile}
                                    onBlur={() => setTouched(prev => ({ ...prev, firstName: true }))}

                                  // disabled={!isEditing} 
                                  />
                                  {/* {isProfileValid.firstNameHasSpace && (
                                    <small className="text-danger mt-1 d-block">{t("no_space_password")}</small>
                                  )} */}
                                  {touched.firstName && profileValidations.firstNameEmpty && (
                                    <small className="text-danger mt-1 d-block">
                                      {t("please_enter_firstname")}
                                    </small>
                                  )}
                                  {/* </div> */}
                                </div>
                                <div className="col-md-6">
                                  {/* <div className="form-group"> */}
                                  <label htmlFor="lname">{t("lastName")}*</label>
                                  <input type="text" className="form-control"
                                    id="lname"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleInputChangeProfile}
                                    onBlur={() => setTouched(prev => ({ ...prev, lastName: true }))}
                                  // disabled={isEditing}
                                  />
                                  {/* {profileValidations.lastNameHasSpace && (
                                    <small className="text-danger mt-1 d-block">{t("no_space_password")}</small>
                                  )} */}
                                  {touched.lastName && profileValidations.lastNameEmpty && (
                                    <small className="text-danger mt-1 d-block">
                                      {t("please_enter_lastname")}
                                    </small>
                                  )}
                                  {/* </div> */}
                                </div>
                                <div className="col-md-6">
                                  {/* <div className="form-group"> */}
                                  <label htmlFor="lname">{t("email_address")}</label>
                                  <div>

                                    <input
                                      type="email"
                                      className="form-control disable pe-auto"
                                      style={{ cursor: "notAllowed" }}
                                      id="lname"
                                      value={formData.PrimaryEmail}
                                      // onChange={handleInputChangeProfile}
                                      disabled={!isEditing}
                                    />
                                    {/* </div> */}
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <label htmlFor="group-options">{t("group")}</label>
                                  <div
                                    ref={groupRef}
                                    className={`custom-dropdown green-icon-drop-down header-dropdown select-wrapper position-relative ${groupAccess !== 1 ? "disable pe-auto" : ""}`}
                                    style={{
                                      position: "relative",
                                      overflow: "visible",
                                    }}
                                  >
                                    <div
                                      role="button"
                                      onClick={toggleGroupDropdown}
                                      className="dropdown-toggle form-control position-relative custom-dropdown-btn ctm-select"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <span>{selectedGroupName}</span>
                                      <span className="dropdown-arrow">{isGroupOpen ? "▲" : "▼"}</span>
                                    </div>

                                    {isGroupOpen && (
                                      <div
                                        className="dropdown-menu-list"
                                        style={{
                                          position: "absolute",
                                          top: "calc(100% + 6px)",
                                          left: "auto",
                                          right: "auto",
                                          zIndex: 1,
                                          background: "#fff",
                                          border: "1px solid var(--color-theme-green)",
                                          borderRadius: "4px",
                                          maxHeight: "240px",
                                          overflowY: "auto",
                                          width: "100%",
                                        }}
                                      >
                                        {/* HARDCODED "NONE" OPTION - Only show if access is allowed */}
                                        {groupAccess === 1 && (
                                          <div
                                            onClick={() => {
                                              handleGroupChange({ target: { value: 0 } });
                                              setIsGroupOpen(false);
                                            }}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "8px",
                                              padding: "8px 12px",
                                              cursor: "pointer",
                                              whiteSpace: "nowrap",
                                              fontFamily: "var(--font-roboto)",
                                              fontSize: "12px",
                                              lineHeight: "24px",
                                              fontWeight: "400",
                                            }}
                                          >
                                            <input
                                              type="radio"
                                              name="groupdropdown"
                                              checked={selectedGroupId === 0}
                                              readOnly
                                              style={{ marginRight: "8px", height: "auto", accentColor: "#1c988a" }}
                                            />
                                            <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}> -- </span>
                                          </div>
                                        )}

                                        {/* DYNAMIC LIST */}
                                        {groups.length > 0 ? (
                                          groups.map((group) => (
                                            <div
                                              key={group.Id}
                                              onClick={() => {
                                                if (groupAccess === 1) {
                                                  handleGroupChange({ target: { value: group.Id } });
                                                  setIsGroupOpen(false);
                                                }
                                              }}
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                padding: "8px 12px",
                                                cursor: groupAccess === 1 ? "pointer" : "default",
                                                whiteSpace: "nowrap",
                                                fontFamily: "var(--font-roboto)",
                                                fontSize: "12px",
                                                lineHeight: "24px",
                                                fontWeight: "400",
                                              }}
                                            >
                                              <input
                                                type="radio"
                                                name="groupdropdown"
                                                value={group.Id}
                                                checked={selectedGroupId === group.Id}
                                                readOnly
                                                style={{
                                                  marginRight: "8px",
                                                  height: "auto",
                                                  accentColor: selectedGroupId === group.Id ? "#1c988a" : "initial",
                                                }}
                                              />
                                              <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                                                {group.Name}
                                              </span>
                                            </div>
                                          ))
                                        ) : (
                                          <div style={{ padding: "8px 12px", color: "#9ca3af" }}>
                                            {t("no_groups_available")}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>

                                {/* Zone Dropdown */}
                                <div className="col-md-6">
                                  {/* <div className="form-group"> */}
                                  <label htmlFor="zone-options">{t("defaultZone")}</label>
                                  <div
                                    ref={zoneRef}
                                    className="custom-dropdown green-icon-drop-down header-dropdown select-wrapper position-relative"
                                    style={{
                                      position: "relative",
                                      overflow: "visible",
                                      zIndex: 1
                                    }}
                                  >
                                    <div
                                      role="button"
                                      onClick={toggleZoneDropdown}
                                      className="dropdown-toggle form-control position-relative custom-dropdown-btn ctm-select"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <span>{selectedZoneName}</span>
                                      <span className="dropdown-arrow">{isZoneOpen ? "▲" : "▼"}</span>
                                    </div>

                                    {isZoneOpen && (
                                      <div
                                        className="dropdown-menu-list"
                                        style={{
                                          position: "absolute",
                                          top: "calc(100% + 6px)",
                                          left: "auto",
                                          right: "auto",
                                          zIndex: 1,
                                          background: "#fff",
                                          border: "1px solid var(--color-theme-green)",
                                          borderRadius: "4px",
                                          // boxShadow: "0 10px 30px rgba(0,0,0,.15)",
                                          maxHeight: "240px",
                                          overflowY: "auto",
                                          width: "100%",
                                        }}
                                      >
                                        {zones.length > 0 ? (
                                          zones.map((zone) => (
                                            <div
                                              key={zone.Id}
                                              onClick={() => {
                                                // handleZoneChange({ target: { value: zone.Id } });
                                                handleZoneChange(zone.Id)
                                                setIsZoneOpen(false);
                                              }}
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                                whiteSpace: "nowrap",
                                                fontFamily: "var(--font-roboto)",
                                                fontSize: "12px",
                                                lineHeight: "24px",
                                                fontWeight: "400",
                                              }}
                                            >
                                              <input
                                                type="radio"
                                                name="zonedropdown"
                                                // CRITICAL: Ensure types match for the check
                                                checked={selectedZoneId === parseInt(zone.Id)}
                                                readOnly // Since the div handles the click
                                                style={{
                                                  marginRight: "8px",
                                                  height: "auto",
                                                  accentColor:
                                                    selectedZoneId === zone.Id ? "#1c988a" : "initial",
                                                }}
                                              />
                                              {/* <input
                                                type="radio"
                                                name="zonedropdown"
                                                value={zone.Id}
                                                checked={selectedZoneId === zone.Id}
                                                readOnly
                                                style={{
                                                  marginRight: "8px",
                                                  height: "auto",
                                                  accentColor:
                                                    selectedZoneId === zone.Id ? "#1c988a" : "initial",
                                                }}
                                              /> */}
                                              <span
                                                style={{
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                }}
                                              >
                                                {zone.ZoneName}
                                              </span>
                                            </div>
                                          ))
                                        ) : (
                                          <div style={{ padding: "8px 12px", color: "#9ca3af" }}>
                                            {t("no_zones_available")}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                  {/* </div> */}
                                </div>
                                <div className="col-md-6">
                                  {/* <div className="form-group"> */}
                                  <label htmlFor="lang-options">{t("language")}</label>
                                  <div className="select-wrapper position-relative">
                                    <LanguageSelector
                                      deferApply
                                      onSelect={(lang) => {
                                        setPendingLanguage(lang);
                                        setLanguageChanged(true);
                                      }}
                                    />
                                  </div>
                                  {/* </div> */}
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label htmlFor="zone-options"></label>
                                  </div></div>
                                <div className="col-12 mt-0">
                                  <div className="d-flex justify-content-between">
                                    <div className="button-wrap-profile d-flex flex-column justify-content-end">
                                      <a href="#" className="main-btn fill-red-btn color-pblack mb-4"
                                        onClick={(e) => { e.preventDefault(); setShowDeleteAccountModal(true); }}>
                                        <img src={Images.Trash} alt="delete" /> <span>{t("react_delete_my_account")}</span>
                                      </a>
                                      <a href={termsUrl} target="_blank" rel="noopener noreferrer" className="black-link">
                                        {t("react_terms_of_use_and_privacy")}
                                      </a>
                                    </div>
                                    <div className="toggle-wrap-profile">
                                      <div className="switcher-list mt-0">
                                        {/* <div className="form-check form-switch">
                                      <label className="form-check-label" htmlFor="remind-email">
                                        Receive Reminder Emails</label>
                                      <input className="form-check-input" type="checkbox" id="remind-email" />
                                    </div> */}
                                        <div className="form-check form-switch">
                                          <label className="form-check-label" htmlFor="calendar-syncs">{t("sync_bookings_with_calendar")}
                                            {/* <i
                                          className="bi bi-info-circle ms-2"
                                          // title="When disabled, you will continue to receive communications about automatic booking cancellations (provided this setting was enabled by your administrator) — to allow you the opportunity to confirm and retain your booking. This is an exception, as all other forms of communications will be turned off."
                                          title={t("receive_reminder_emails_tooltip_message")}
                                          style={{ cursor: 'help', fontSize: '14px', color: '#1c988a' }}
                                        ><img src={Tooltipicon} alt="tooltip" /></i> */}
                                          </label>
                                          {SyncCalendarStatus !== null && (
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id="calendar-sync"
                                              name="syncCalendar"
                                              checked={SyncCalendarStatus}
                                              onChange={ToggleSyncbookingswithcalenda}
                                            />
                                          )}
                                        </div>

                                        <div className="form-check form-switch"><label className="form-check-label">
                                          {t("receive_reminder_emails")}
                                          <i
                                            className="bi bi-info-circle ms-2"
                                            title={t("receive_reminder_emails_tooltip_message")}
                                            style={{ cursor: 'help', fontSize: '14px', color: '#1c988a' }}
                                          ><img src={Tooltipicon} alt="tooltip" /></i></label>
                                          {emailNotification !== null && (
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id="remind-email"
                                              name="remindEmail"
                                              checked={emailNotification} // Bind the checked state
                                              onChange={handleNotificationsEmail}
                                              style={{ margin: 0 }} /* Removes default margins for better alignment */
                                            // checked={formData.remindEmail} // Bind to the state
                                            // onChange={handleInputChangeProfile}
                                            />
                                          )}
                                        </div>

                                        <div className="form-check form-switch"><label className="form-check-label">
                                          {t("receive_reminder_notification")}
                                          <i
                                            className="bi bi-info-circle ms-2"
                                            title={t("receive_reminder_emails_tooltip_message")}
                                            style={{ cursor: 'help', fontSize: '14px', color: '#1c988a' }}
                                          >
                                            <img src={Tooltipicon} alt="tooltip" />
                                          </i>
                                        </label>
                                          {notificationsEnabled !== null && (
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id="remind-notify"
                                              name="remindNotification"
                                              checked={notificationsEnabled} // Bind the checked state
                                              onChange={handleNotificationsToggle}
                                            // checked={formData.remindEmail} // Bind to the state
                                            // onChange={handleInputChangeProfile}
                                            />
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="bottom-action-btn d-flex justify-content-end tags-btn gap-3">
                            <button onClick={discardAll} type="button" className="gray-outline-btn">{t("cancel")}</button>
                            <button
                              disabled={profileHasEmpty}
                              type="button" onClick={handleSaveAll} className="selected">{t("save_changes")}</button>
                          </div>
                        </form>
                      </div>



                      <div className={`tab-pane fade ${activeTab === "vehicle-setting" ? "show active" : ""}`}>

                        {/* {vehicleAccess === 0 && (
    <div 
      onClick={handleDisabledClick}
      style={{
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        zIndex: 10,
        cursor: 'not-allowed',
        backgroundColor: 'transparent' 
      }}
    />
  )} */}
                        {/* <VehicleSettings /> */}
                        <div className="setting-form-details vehicle-setting-details mt-5">
                          <div className="height-wrapper">
                            <div
                              // onClick={handleDisabledClick}
                              className={`setting-cards${vehicleAccess === 1 ? "profile-disable" : ""}`}
                            >
                              <form action="#" className="form-elements">
                                {
                                  isLoading ? (
                                    <div style={{ textAlign: 'center' }}>
                                      {/* <img src={loadingGIF} alt="Loading" /> */}
                                    </div>
                                  ) :
                                    vehicleCards.length === 0 ? (
                                      <p>
                                        {/* No vehicles available */}

                                      </p>
                                    ) : vehicleCards.map((card, position) => {
                                      // Saved vehicles and unsaved add-vehicle drafts share one
                                      // draggable list (useVehicleCardOrder). The aliases below let
                                      // both card bodies keep the names they already used.
                                      const vehicle = card.vehicle;
                                      const draftVehicle = card.draft;
                                      const draftIndex = card.draftIndex;

                                      return (
                                        <div
                                          key={card.key}
                                          className={`vehicle-card${draggingCardKey === card.key ? " is-dragging" : ""}`}
                                          {...cardDragProps(card.key)}
                                        >
                                          <button
                                            type="button"
                                            className="vehicle-drag-handle"
                                            aria-label={`${t("vehicle")} ${position + 1}`}
                                            {...dragHandleProps(card.key)}
                                          >
                                            <img src={greyUpDownArrow} alt="" />
                                          </button>

                                          {card.kind === "saved" ? (
                                            <div className="row g-4">
                                              <div className="col-md-5">
                                                {/* <div className="form-group"> */}
                                                <label htmlFor={`registrationName-${vehicle.Id}`} >{t("vehicle")} {position + 1} </label>
                                                <input
                                                  type="text"
                                                  className={`form-control ${vehicleFieldStatus.existing?.[vehicle.Id] === "error"
                                                    ? "error-form"
                                                    : vehicleFieldStatus.existing?.[vehicle.Id] === "success"
                                                      ? "success-validation"
                                                      : ""
                                                    }`}
                                                  id={`registrationName-${vehicle.Id}`}
                                                  name="RegistrationName"
                                                  value={vehicle.RegistrationName}
                                                  onChange={(event) => handleVehicleInputChange(event, vehicle.Id)}
                                                />
                                                {vehicleFieldStatus.existing?.[vehicle.Id] === "error" && (
                                                  <div className="error-text">
                                                    <img src={Images.ErrorMsg} alt="" />
                                                    <p>{t("react_vehicle_number_plate")}</p>
                                                  </div>
                                                )}
                                                {/* </div> */}
                                                {/* Cards are draggable, so "not the first one" is no
                                                    longer a stable rule: the link shows on every saved
                                                    card and only disappears on the last one, keeping at
                                                    least one vehicle registered. */}
                                                {vehicles.length > 1 && (
                                                  <div
                                                    className="mt-3 d-inline-flex align-items-center gap-2 text-dark"
                                                    style={{ cursor: 'pointer', fontSize: '14px' }}
                                                    // onClick={() => handleDeleteVehicle(vehicle.Id, vehicle.FuelId, vehicle.RegistrationName, vehicle.TypeId, vehicle.ShareableId, vehicle.AccessibleId)}
                                                    onClick={() => openDeletePopup(vehicle)}
                                                  >
                                                    {/* <div style={{
                                                      backgroundColor: '#333',
                                                      width: '28px',
                                                      height: '28px',
                                                      borderRadius: '50%',
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      justifyContent: 'center'
                                                    }}> */}
                                                    <img src={trashRed}
                                                      alt="Delete"
                                                    // style={{ width: '14px', filter: 'invert(1)' }} 
                                                    />
                                                    <span className="fw-bold text-red">{t("react_remove_vehicle")}</span>
                                                    {/* </div> */}
                                                    {/* <span className="fw-bold">{t("remove")} {t("vehicle")}</span> */}
                                                  </div>
                                                )}
                                              </div>

                                              <div className="col-md-3">
                                                <div className="size-type-options">
                                                  <div className="dropdown form-input-container d-flex justify-content-center flex-column rect-dropdown rect-dropdown-without-arrow">
                                                    <button
                                                      className="form-control position-relative custom-dropdown-btn text-start"
                                                      type="button"
                                                      onClick={() => openSizePopup(vehicle)} // Trigger the popup here
                                                    >
                                                      <img src={steering} alt="" />
                                                      <span>{vehicle.TypeName || "Size type"}</span>
                                                      <i className="bi bi-chevron-down ms-auto"></i>
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col-md-4">
                                                <div className="vehicle-options">
                                                  <div className="dropdown form-input-container d-flex justify-content-center flex-column rect-dropdown">
                                                    {/* <button className="dropdown-toggle form-control position-relative custom-dropdown-btn" */}
                                                    <button className={`dropdown-toggle form-control position-relative custom-dropdown-btn ${openFuelVehicleId === vehicle.Id ? "show" : ""}`}
                                                      type="button" id="fuel-option-btn" data-bs-toggle="dropdown" name="deskdropdown" required
                                                      onClick={() => setOpenFuelVehicleId(openFuelVehicleId === vehicle.Id ? null : vehicle.Id)}>
                                                      <img src={fuel} alt="" />
                                                      <span>{vehicle.FuelType}</span>
                                                    </button>
                                                    {/* <ul className="dropdown-menu custom-dropdown" aria-labelledby="fuel-option" id="fuel-option"> */}
                                                    <ul className={`dropdown-menu custom-dropdown ${openFuelVehicleId === vehicle.Id ? "show" : ""}`}>
                                                      {AllowedFuelTypes.map((grp) => (
                                                        <li
                                                          key={grp.Id}
                                                          // Only apply 'selected' if this item matches the vehicle's current fuel type
                                                          className={vehicle.FuelType === grp.Name ? "selected" : ""}
                                                          onClick={() => {
                                                            handleFuelTypeChange(vehicle.Id, grp.Name, grp.Id);
                                                            setOpenFuelVehicleId(null);
                                                          }}
                                                        >
                                                          <button
                                                            type="button"
                                                            className={`dropdown-item ${vehicle.FuelType === grp.Name ? "active" : ""}`}
                                                          >
                                                            {grp.Name}
                                                          </button>
                                                        </li>
                                                      ))}
                                                    </ul>
                                                    {/* <ul className="dropdown-menu custom-dropdown" aria-labelledby="fuel-option" id="fuel-option">
                                                      {AllowedFuelTypes.map((grp) => (
                                                        <li
                                                          key={grp.Id}
                                                          className="selected"
                                                          onClick={() => handleFuelTypeChange(vehicle.Id, grp.Name, grp.Id)}
                                                        >
                                                          <a className="dropdown-item" href="javascript:void(0);">{grp.Name}</a>
                                                        </li>
                                                      ))}
                                                    </ul> */}
                                                  </div>
                                                  {AllowedAccessibleTypes.length > 0 && (
                                                    <div className="dropdown form-input-container d-flex justify-content-center flex-column rect-dropdown">
                                                      <button className={`dropdown-toggle form-control position-relative custom-dropdown-btn ${openAccessibleVehicleId === vehicle.Id ? "show" : ""}`}
                                                        type="button" id="accesible-option-btn" data-bs-toggle="dropdown" aria-expanded="false" name="deskdropdown" required
                                                        onClick={() => setOpenAccessibleVehicleId(openAccessibleVehicleId === vehicle.Id ? null : vehicle.Id)}>
                                                        <img src={menwithcycle} alt="" />
                                                        {/* <span>{vehicle.AccessibleType}</span> */}
                                                        <span>{vehicle.AccessibleId === 0 ? t("react_non_accesible") : vehicle.AccessibleType}</span>
                                                      </button>
                                                      <ul className={`dropdown-menu custom-dropdown ${openAccessibleVehicleId === vehicle.Id ? "show" : ""}`} aria-labelledby="accesible-option" id="accesible-option">
                                                        {/* Default Empty Option */}
                                                        <li
                                                          className={vehicle.AccessibleId === 0 ? "selected" : ""}
                                                          onClick={() => {
                                                            setVehicles(prev => prev.map(v =>
                                                              v.Id === vehicle.Id ? { ...v, AccessibleType: t("react_non_accesible"), AccessibleId: 0 } : v
                                                            ));
                                                            setVehicleUpdated(true);
                                                            setOpenAccessibleVehicleId(null);
                                                          }}
                                                        >
                                                          <button type="button" className={`dropdown-item ${vehicle.AccessibleId === 0 ? "active" : "text-muted"}`}> {t("react_non_accesible")} </button>
                                                        </li>

                                                        {/* <hr className="dropdown-divider" /> */}

                                                        {/* Mapped Options */}
                                                        {AllowedAccessibleTypes.map((grp) => (
                                                          <li
                                                            key={grp.Id}
                                                            // Only apply 'selected' class if the IDs match
                                                            className={vehicle.AccessibleId === grp.Id ? "selected" : ""}
                                                            onClick={() => {
                                                              handleAccessibleTypeChange(vehicle.Id, grp.Name, grp.Id);
                                                              setOpenAccessibleVehicleId(null);
                                                            }}
                                                          >
                                                            <button
                                                              type="button"
                                                              className={`dropdown-item ${vehicle.AccessibleId === grp.Id ? "active" : ""}`}
                                                            >
                                                              {grp.Name}
                                                            </button>
                                                          </li>
                                                        ))}
                                                      </ul>
                                                      {/* <ul className="dropdown-menu custom-dropdown" aria-labelledby="accesible-option" id="accesible-option">

                                                      <li onClick={() => {
                                                        setVehicles(prev => prev.map(v =>
                                                          v.Id === vehicle.Id ? { ...v, AccessibleType: "Select Accessible", AccessibleId: 0 } : v
                                                        ));
                                                      }}>
                                                        <a className="dropdown-item text-muted" href="javascript:void(0);"> --</a>
                                                      </li>
                                                      <hr className="dropdown-divider" />

                                                      {AllowedAccessibleTypes.map((grp) => (
                                                        <li
                                                          key={grp.Id}
                                                          className="selected"
                                                          onClick={() => handleAccessibleTypeChange(vehicle.Id, grp.Name, grp.Id)}
                                                        >
                                                          <a className="dropdown-item" href="javascript:void(0);">{grp.Name}</a>
                                                        </li>
                                                      ))}
                                                    </ul> */}
                                                    </div>
                                                  )}
                                                  {AllowedShareableTypes.length > 0 && (
                                                    <div className="dropdown form-input-container d-flex justify-content-center flex-column rect-dropdown">
                                                      <button className={`dropdown-toggle form-control position-relative custom-dropdown-btn ${openShareableVehicleId === vehicle.Id ? "show" : ""}`} type="button" id="shareable-option-btn" data-bs-toggle="dropdown" aria-expanded="false" name="deskdropdown" required
                                                        onClick={() => setOpenShareableVehicleId(openShareableVehicleId === vehicle.Id ? null : vehicle.Id)}>
                                                        <img src={carwithmark} alt="" />
                                                        {/* <span>{vehicle.ShareableType}</span> */}
                                                        <span>{vehicle.ShareableId === 0 ? t("react_non_shareable") : vehicle.ShareableType}</span>
                                                      </button>
                                                      <ul className={`dropdown-menu custom-dropdown ${openShareableVehicleId === vehicle.Id ? "show" : ""}`} aria-labelledby="shareable-option" id="shareable-option">
                                                        {/* Default Empty Option */}
                                                        <li
                                                          className={vehicle.ShareableId === 0 ? "selected" : ""}
                                                          onClick={() => {
                                                            setVehicles(prev => prev.map(v =>
                                                              v.Id === vehicle.Id ? { ...v, ShareableType: "Shareable", ShareableId: 0 } : v
                                                            ));
                                                            setVehicleUpdated(true); // Trigger unsaved changes flag
                                                            setOpenShareableVehicleId(null);
                                                          }}
                                                        >
                                                          <button type="button" className={`dropdown-item ${vehicle.ShareableId === 0 ? "active" : "text-muted"}`}> {t("react_non_shareable")} </button>
                                                        </li>

                                                        {/* <hr className="dropdown-divider" /> */}

                                                        {/* Mapped Options */}
                                                        {AllowedShareableTypes.map((grp) => (
                                                          <li
                                                            key={grp.Id}
                                                            // Apply 'selected' class only if this ID is the one currently saved in state
                                                            className={vehicle.ShareableId === grp.Id ? "selected" : ""}
                                                            onClick={() => {
                                                              handleSharingTypeChange(vehicle.Id, grp.Name, grp.Id);
                                                              setOpenShareableVehicleId(null);
                                                            }}
                                                          >
                                                            <button
                                                              type="button"
                                                              className={`dropdown-item ${vehicle.ShareableId === grp.Id ? "active" : ""}`}
                                                            >
                                                              {grp.Name}
                                                            </button>
                                                          </li>
                                                        ))}
                                                      </ul>
                                                      {/* <ul className="dropdown-menu custom-dropdown" aria-labelledby="shareable-option" id="shareable-option">
                                                      Default Empty Option
                                                      <li onClick={() => {
                                                        setVehicles(prev => prev.map(v =>
                                                          v.Id === vehicle.Id ? { ...v, ShareableType: "Select Shareable", ShareableId: 0 } : v
                                                        ));
                                                      }}>
                                                        <a className="dropdown-item text-muted" href="javascript:void(0);"> -- </a>
                                                      </li>
                                                      <hr className="dropdown-divider" />

                                                      Mapped Options
                                                      {AllowedShareableTypes.map((grp) => (
                                                        <li
                                                          key={grp.Id}
                                                          className="selected"
                                                          onClick={() => handleSharingTypeChange(vehicle.Id, grp.Name, grp.Id)}
                                                        >
                                                          <a className="dropdown-item" href="javascript:void(0);">{grp.Name}</a>
                                                        </li>
                                                      ))}
                                                    </ul> */}
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          ) : (
                                            <div className="row g-4" style={{ position: "relative" }}>
                                              <div className="col-md-5">
                                                <label>{t("vehicle")} {position + 1}</label>
                                                <input
                                                  className={`form-control custom-input-white ${vehicleFieldStatus.drafts?.[draftIndex] === "error"
                                                    ? "error-form"
                                                    : vehicleFieldStatus.drafts?.[draftIndex] === "success"
                                                      ? "success-validation"
                                                      : ""
                                                    }`}
                                                  type="text"
                                                  id={`vehicle-draft-${draftIndex}`}
                                                  placeholder={t("vehicle_plate_placeholder")}
                                                  value={draftVehicle.VehicleNumber}
                                                  onChange={(e) => {
                                                    const rawValue = e.target.value;
                                                    const cleanValue = rawValue.replace(/[^a-zA-Z0-9\s]/g, "");
                                                    updateNewVehicleDraft(draftIndex, { VehicleNumber: cleanValue });
                                                    setValidationError("");
                                                    // Only react once this draft has been validated: empty → red, filled → green.
                                                    setVehicleFieldStatus((prev) => {
                                                      if (!prev.drafts[draftIndex]) return prev;
                                                      const nextDrafts = { ...prev.drafts, [draftIndex]: cleanValue.trim() !== "" ? "success" : "error" };
                                                      return { ...prev, drafts: nextDrafts };
                                                    });
                                                    if (cleanValue.trim() !== "") {
                                                      setVehicleAdded(true);
                                                    }
                                                  }}
                                                />
                                                {vehicleFieldStatus.drafts?.[draftIndex] === "error" && (
                                                  <div className="error-text">
                                                    <img src={Images.ErrorMsg} alt="" />
                                                    <p>{t("react_vehicle_number_plate")}</p>
                                                  </div>
                                                )}
                                                <div
                                                  className="mt-3 d-inline-flex align-items-center gap-2 text-dark"
                                                  style={{ cursor: 'pointer', fontSize: '14px' }}
                                                  onClick={() => removeNewVehicleDraft(draftIndex)}>
                                                  <img src={trashRed} alt="Delete" />
                                                  <span className="fw-bold text-red">{t("react_remove_vehicle")}</span>
                                                </div>
                                              </div>

                                              <div className="col-md-3">
                                                <div className="size-type-options">
                                                  <div className="dropdown form-input-container d-flex justify-content-center flex-column rect-dropdown rect-dropdown-without-arrow">
                                                    <button
                                                      type="button"
                                                      className="form-control position-relative custom-dropdown-btn text-start"
                                                      onClick={() => {
                                                        setPopupAllowedVehicleTypes(draftVehicle.VehicleSizeId || AllowedVehicleTypes[0]?.Id || null);
                                                        setAddSizePopupVisible(draftIndex);
                                                      }}
                                                    >
                                                      <img src={steering} alt="" />
                                                      <span>
                                                        {
                                                          AllowedVehicleTypes.find((group) => String(group.Id) === String(draftVehicle.VehicleSizeId))?.Name ||
                                                          AllowedVehicleTypes[0]?.Name ||
                                                          "Size type"
                                                        }
                                                      </span>
                                                      <i className="bi bi-chevron-down ms-auto"></i>
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                              {/* Add Vehicle Size Popup */}
                                              {addSizePopupVisible !== null && (
                                                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}>
                                                  <div className="modal-dialog modal-dialog-centered modal-custom-width-long">
                                                    <div className="modal-content modal-radius">
                                                      <div className="modal-body">
                                                        <div className="custom-popup-overlay">
                                                          <div className="vehicle-type-modal-content">
                                                            <div className="d-flex justify-content-between align-items-center mb-4">
                                                              <h5 className="popup-title">{t("vehicle_type")}</h5>
                                                              <div className="close-modal">
                                                                <a onClick={() => setAddSizePopupVisible(null)}>
                                                                  <img src={closeIcon} alt="Close" />
                                                                </a>
                                                              </div>
                                                            </div>

                                                            <div className="vehicle-type-grid">
                                                              {AllowedVehicleTypes?.map((grp) => (
                                                                <div
                                                                  key={grp.Id}
                                                                  className={`type-card ${popupAllowedVehicleTypes === grp.Id ? 'active' : ''}`}
                                                                  onClick={() => {
                                                                    setPopupAllowedVehicleTypes(grp.Id);
                                                                    updateNewVehicleDraft(addSizePopupVisible, { VehicleSizeId: grp.Id });
                                                                    setVehicleAdded(true);
                                                                    setAddSizePopupVisible(null);
                                                                  }}
                                                                >
                                                                  <div className="type-icon-wrapper">
                                                                    <img src={getVehicleIconById(grp.Id)} alt={grp.Name} />
                                                                  </div>
                                                                  <div className="text-center">
                                                                    <span className={`type-info ${popupAllowedVehicleTypes === grp.Id ? 'text-success' : ''}`}>
                                                                      {grp.Name}
                                                                    </span>
                                                                  </div>
                                                                </div>
                                                              ))}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                              <div className="col-md-4">
                                                <div className="vehicle-options">
                                                  <div className="dropdown form-input-container d-flex justify-content-center flex-column rect-dropdown">
                                                    <button className={`dropdown-toggle form-control position-relative custom-dropdown-btn ${openNewFuelDraftIndex === draftIndex ? "show" : ""}`}
                                                      type="button"
                                                      id={`fuel-option-btn-${draftIndex}`}
                                                      data-bs-toggle="dropdown"
                                                      name="deskdropdown"
                                                      onClick={() => setOpenNewFuelDraftIndex((currentIndex) => (currentIndex === draftIndex ? null : draftIndex))}
                                                    >
                                                      <img src={fuel} alt="fuel" className="me-2" />
                                                      <span>
                                                        {/* Display the selected name */}
                                                        {AllowedFuelTypes.find(f => String(f.Id) === String(draftVehicle.VehicleFuelId))?.Name
                                                          || AllowedFuelTypes[0]?.Name
                                                          || "Fuel type"}
                                                      </span>
                                                    </button>

                                                    <ul className={`dropdown-menu custom-dropdown ${openNewFuelDraftIndex === draftIndex ? "show" : ""}`}>
                                                      {AllowedFuelTypes.map((grp) => (
                                                        <li
                                                          key={grp.Id}
                                                          className={String(draftVehicle.VehicleFuelId) === String(grp.Id) ? "selected" : ""}
                                                          onClick={() => {
                                                            handlepopupFuleTypeChange(draftIndex, grp.Id);
                                                            setVehicleAdded(true);
                                                            setOpenNewFuelDraftIndex(null);
                                                          }}
                                                        >
                                                          <a
                                                            className={`dropdown-item ${String(draftVehicle.VehicleFuelId) === String(grp.Id) ? "active" : ""}`}
                                                            href="javascript:void(0);"
                                                          >
                                                            {grp.Name}
                                                          </a>
                                                        </li>
                                                      ))}
                                                    </ul>
                                                  </div>
                                                  {AllowedAccessibleTypes.length > 0 && (
                                                    <div className="dropdown form-input-container d-flex justify-content-center flex-column rect-dropdown">
                                                      <button
                                                        className={`dropdown-toggle form-control position-relative custom-dropdown-btn ${openNewAccessibleDraftIndex === draftIndex ? "show" : ""}`}
                                                        type="button"
                                                        id={`popup-accessible-btn-${draftIndex}`}
                                                        data-bs-toggle="dropdown"
                                                        onClick={() =>
                                                          setOpenNewAccessibleDraftIndex((currentIndex) =>
                                                            currentIndex === draftIndex ? null : draftIndex
                                                          )
                                                        }
                                                      >
                                                        <img src={menwithcycle} alt="" className="me-2" />
                                                        <span>
                                                          {draftVehicle.VehicleAccessibleId === 0 || !draftVehicle.VehicleAccessibleId
                                                            ? t("react_non_accesible")
                                                            : AllowedAccessibleTypes.find(a => String(a.Id) === String(draftVehicle.VehicleAccessibleId))?.Name}
                                                        </span>
                                                      </button>

                                                      <ul className={`dropdown-menu custom-dropdown ${openNewAccessibleDraftIndex === draftIndex ? "show" : ""}`} aria-labelledby={`popup-accessible-btn-${draftIndex}`}>
                                                        <li
                                                          className={(!draftVehicle.VehicleAccessibleId || draftVehicle.VehicleAccessibleId === 0) ? "selected" : ""}
                                                          onClick={() => {
                                                            handlepopupAccessibleTypesChange(draftIndex, 0);
                                                            setVehicleAdded(true);
                                                            setOpenNewAccessibleDraftIndex(null);
                                                          }}
                                                        >
                                                          <button type="button" className={`dropdown-item ${draftVehicle.VehicleAccessibleId === 0 ? "active" : "text-muted"}`}> {t("react_non_accesible")} </button>
                                                        </li>

                                                        {AllowedAccessibleTypes.map((grp) => (
                                                          <li
                                                            key={grp.Id}
                                                            className={String(draftVehicle.VehicleAccessibleId) === String(grp.Id) ? "selected" : ""}
                                                            onClick={() => {
                                                              handlepopupAccessibleTypesChange(draftIndex, grp.Id);
                                                              setVehicleAdded(true);
                                                              setOpenNewAccessibleDraftIndex(null);
                                                            }}
                                                          >
                                                            <button type="button" className={`dropdown-item ${String(draftVehicle.VehicleAccessibleId) === String(grp.Id) ? "active" : ""}`}>
                                                              {grp.Name}
                                                            </button>
                                                          </li>
                                                        ))}
                                                      </ul>
                                                    </div>
                                                  )}
                                                  {AllowedShareableTypes.length > 0 && (
                                                    <div className="dropdown form-input-container d-flex justify-content-center flex-column rect-dropdown">
                                                      <button
                                                        className={`dropdown-toggle form-control position-relative custom-dropdown-btn ${openNewShareableDraftIndex === draftIndex ? "show" : ""}`}
                                                        type="button"
                                                        id={`popup-shareable-btn-${draftIndex}`}
                                                        data-bs-toggle="dropdown"
                                                        onClick={() =>
                                                          setOpenNewShareableDraftIndex((currentIndex) =>
                                                            currentIndex === draftIndex ? null : draftIndex
                                                          )
                                                        }
                                                      >
                                                        <img src={carwithmark} alt="" className="me-2" />
                                                        <span>
                                                          {draftVehicle.VehicleShareableId === 0 || !draftVehicle.VehicleShareableId
                                                            ? t("react_non_shareable")
                                                            : AllowedShareableTypes.find(s => String(s.Id) === String(draftVehicle.VehicleShareableId))?.Name}
                                                        </span>
                                                      </button>

                                                      <ul className={`dropdown-menu custom-dropdown ${openNewShareableDraftIndex === draftIndex ? "show" : ""}`} aria-labelledby={`popup-shareable-btn-${draftIndex}`}>
                                                        <li
                                                          className={(!draftVehicle.VehicleShareableId || draftVehicle.VehicleShareableId === 0) ? "selected" : ""}
                                                          onClick={() => {
                                                            handlepopupShareableTypesChange(draftIndex, 0);
                                                            setVehicleAdded(true);
                                                            setOpenNewShareableDraftIndex(null);
                                                          }}
                                                        >
                                                          <button type="button" className={`dropdown-item ${draftVehicle.VehicleShareableId === 0 ? "active" : "text-muted"}`}> {t("react_non_shareable")} </button>
                                                        </li>

                                                        {AllowedShareableTypes.map((grp) => (
                                                          <li
                                                            key={grp.Id}
                                                            className={String(draftVehicle.VehicleShareableId) === String(grp.Id) ? "selected" : ""}
                                                            onClick={() => {
                                                              handlepopupShareableTypesChange(draftIndex, grp.Id);
                                                              setVehicleAdded(true);
                                                              setOpenNewShareableDraftIndex(null);
                                                            }}
                                                          >
                                                            <button type="button" className={`dropdown-item ${String(draftVehicle.VehicleShareableId) === String(grp.Id) ? "active" : ""}`}>
                                                              {grp.Name}
                                                            </button>
                                                          </li>
                                                        ))}
                                                      </ul>
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })
                                }

                                {error && <div style={{ color: 'red' }}>{error}</div>}

                                {/* {showAlertPopupModal && (
                                        <AlertPopupModal
                                            title={alertPopupModalData?.title}
                                            message={alertPopupModalData?.message}
                                            onClose={() => setShowAlertPopupModal(false)}
                                        />
                                    )}

                                    {showErrorPopupModal && (
                                        <ErrorPopupModal
                                            title={errorPopupModalData?.title}
                                            message={errorPopupModalData?.message}
                                            onClose={() => setShowErrorPopupModal(false)}
                                        />
                                    )} */}

                                <div className="mt-4">
                                  <a className="green-filled-with-icon"
                                    href="#"
                                    onClick={handleAddVehicleClick}>
                                    <span><img src={whiteplus} alt="" /></span>{t("react_add_vehicle")} </a>
                                </div>

                                {/* &nbsp; */}

                                {sizePopupVisible && (
                                  <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                                  >
                                    <div className="modal-dialog modal-dialog-centered modal-custom-width-long">
                                      <div className="modal-content modal-radius">
                                        <div className="modal-body">
                                          <div className="custom-popup-overlay">
                                            <div className="vehicle-type-modal-content">
                                              <div className="d-flex justify-content-between align-items-center mb-4">
                                                <h5 className="popup-title">{t("vehicle_type")}</h5>
                                                <div className="close-modal">
                                                  <a onClick={() => setSizePopupVisible(false)}>
                                                    <img src={closeIcon} aria-label="Close" />
                                                  </a>
                                                </div>
                                                {/* <button className="close-btn-circle" onClick={() => setSizePopupVisible(false)}>
                                                <img src={closeIcon} alt="close" />
                                              </button> */}
                                              </div>

                                              <div className="vehicle-type-grid">
                                                {AllowedVehicleTypes.map((grp) => (
                                                  <div
                                                    key={grp.Id}
                                                    className={`type-card ${activeVehicleForSize?.TypeId === grp.Id ? 'active' : ''}`}
                                                    onClick={() => {
                                                      // setVehicles(prev => prev.map(v => 
                                                      //   v.Id === activeVehicleForSize.Id ? { ...v, TypeName: grp.Name, TypeId: grp.Id } : v
                                                      // ));
                                                      setVehicles(prev => {
                                                        const updated = prev.map(v =>
                                                          v.Id === activeVehicleForSize.Id
                                                            ? { ...v, TypeName: grp.Name, TypeId: grp.Id }
                                                            : v
                                                        );
                                                        return updated;
                                                      });

                                                      setVehicleUpdated(true);
                                                      setSizePopupVisible(false);
                                                    }}
                                                  >
                                                    <div className="type-icon-wrapper">
                                                      {/* Call the helper function using the grp.Id */}
                                                      <img
                                                        src={getVehicleIconById(grp.Id)}
                                                        alt={grp.Name}
                                                      // style={{ width: '40px', height: 'auto' }}
                                                      />
                                                    </div>
                                                    <div className="text-center">
                                                      <span className={`type-info ${activeVehicleForSize?.TypeId === grp.Id ? 'text-success' : ''}`}>
                                                        {grp.Name}
                                                      </span>
                                                      {/* <small className="text-muted" style={{ fontSize: '10px' }}>
                                                        {grp.Description || ""}
                                                      </small> */}
                                                    </div>
                                                  </div>
                                                ))}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div></div></div>
                                )}

                                {deletePopupVisible && (
                                  <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(217, 217, 217, 0.59)' }}
                                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                                  >

                                    <div className="modal fade show alertpopup d-block">
                                      <div className="modal-dialog modal-dialog-centered modal-custom-width">
                                        <div className="modal-content modal-radius">
                                          <div className="modal-body">
                                            <div className="close-modal">
                                              <a onClick={() => setDeletePopupVisible(false)}>
                                                <img src={closeIcon} aria-label="Close" />
                                              </a>
                                            </div>

                                            {/* Title */}
                                            <div className="pt-4">
                                              <h5 className="popup-title">{t("warning")}</h5>
                                            </div>
                                            <div className="modal-des pt-4">
                                              <p>
                                                {t("react_do_you_want_delete_car_plate")}{" "}
                                                <span className="color-green fw-bold">{vehicleToDelete?.RegistrationName}</span>?
                                              </p>
                                              <div className="modal-img text-center"><img className="warning-icon" src={WarningIcon} alt="Warning Icon" /></div>

                                              <div className="d-flex justify-content-end gap-3 mt-4">
                                                <button
                                                  type="button"
                                                  className="main-btn outline-alert-btn w-full"
                                                  onClick={confirmDeleteVehicle}
                                                >
                                                  {t("confirm")}
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div></div></div></div>
                                  // </div>
                                )}

                                {/* <div className="mt-4">
                                  <a className="green-filled-with-icon"
                                    href="#"
                                    onClick={handleAddVehicleClick}>
                                    <span><img src={whiteplus} alt="" /></span>{t("react_add_vehicle")} </a>
                                </div> */}
                              </form>
                            </div>
                          </div>
                          <div className="bottom-action-btn d-flex justify-content-end tags-btn gap-3">
                            <button onClick={discardAll} type="button" className="gray-outline-btn">{t("cancel")}</button>
                            {/* <button type="button" className="selected" onClick={handleVehicleUpdate}>Save changes</button> */}
                            <button type="button" className="selected" onClick={handleSaveAll}>{t("save_changes")}</button>
                          </div>
                        </div>
                      </div>
                      {!isSSOLogin && (
                        <div className={`tab-pane fade ${activeTab === "password-setting" ? "show active" : ""}`}>
                          {/* <Password /> */}
                          <div className="setting-form-details">

                            <form className="form-elements mt-5" onSubmit={(e) => e.preventDefault()}>
                              <div className="height-wrapper">
                                <div className="row g-4">

                                  <div className="col-md-12">
                                    <label>{t("old_password")}</label>
                                    <div className="psw-bind position-relative">
                                      <input
                                        type={showOld ? "text" : "password"}
                                        className="form-control custom-input"
                                        name="old"
                                        autoComplete="one-time-code"
                                        value={passwords.old}
                                        onChange={handleInputChange}
                                        required
                                      />
                                      <img src={showOld ? grayeye : greeneye} className="eye" onClick={() => setShowOld(!showOld)} alt="toggle" />
                                    </div>

                                    {passwords.new && !passwords.old && (
                                      <small className="text-danger mt-1 d-block">{t("old_password")}</small>
                                    )}
                                    {spacevalidations.oldHasSpace && (
                                      <small className="text-danger mt-1 d-block">{t("no_space_password")}</small>
                                    )}
                                  </div>

                                  <div className="col-md-12">
                                    <label>{t("tag_new_password")}</label>
                                    <div className="psw-bind position-relative">
                                      <input
                                        type={showNew ? "text" : "password"}
                                        className="form-control custom-input"
                                        name="new"
                                        autoComplete="new-password"
                                        value={passwords.new}
                                        onChange={handleInputChange}
                                      />
                                      <img src={showNew ? grayeye : greeneye} className="icon" onClick={() => setShowNew(!showNew)} alt="toggle" />
                                    </div>

                                    {/* Requirements show ONLY when user starts typing */}
                                    {passwords.new && (
                                      <div className="password-requirements mt-2">
                                        {/* <p className={passwords.new.length >= 10 ? "text-success" : "text-danger"}>
                                            <span className="icon">
                                              <img src={passwords.new.length >= 10 ? "greentick" : redcross} alt="" />
                                            </span> At least 10 characters
                                          </p> */}
                                        <small className={validations.complexity ? "text-success" : "text-danger"}>
                                          <span className="icon">
                                            {/* <img src={validations.complexity ? "greentick" : redcross} alt="" /> */}
                                            <img src={validations.complexity ? greencheck : redcross} alt="" />
                                          </span> {t("must_contain_all_char")}
                                        </small>
                                      </div>
                                    )}
                                    <span className="icon">

                                      {validations.newHasSpace && (
                                        <small className="text-danger mt-1 d-block">{t("no_space_password")}</small>
                                      )}
                                      {passwords.new && !validations.isMinLength && (
                                        <small className="text-danger mt-1 d-block">{t("Mini_length_eight_password")}</small>
                                      )}
                                    </span>
                                  </div>

                                  <div className="col-md-12">
                                    <label>{t("confirm_password")}</label>
                                    <div className="psw-bind position-relative">
                                      <input
                                        type={showConfirm ? "text" : "password"}
                                        className="form-control custom-input"
                                        name="confirm"
                                        value={passwords.confirm}
                                        onChange={handleInputChange}
                                      />
                                      <img src={showConfirm ? grayeye : greeneye} className="icon" onClick={() => setShowConfirm(!showConfirm)} alt="toggle" />
                                    </div>
                                    {passwords.confirm && !validations.match && (
                                      <small className="text-danger mt-1 small">{t("new_password_and_re_enter_password_must_be_same")}</small>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </form>

                          </div>
                          <div className="bottom-action-btn d-flex justify-content-end tags-btn gap-3 mt-4">
                            <button onClick={discardAll} type="button" className="gray-outline-btn">{t("cancel")}</button>
                            <button
                              type="button"
                              // className={(profileChanged || vehicleUpdated || vehicleAdded || (passwords.new && isFormValid)) ? "selected" : "btn-disabled selected"}
                              className={(passwords.new && isFormValid) ? "selected" : "btn-disabled selected"}
                              // disabled={
                              //   isLoading ||
                              //   (passwords.new.length > 0 && !isFormValid) ||
                              //   (!profileChanged && !vehicleUpdated && !vehicleAdded && !passwords.new)
                              // }
                              onClick={handleSaveAll}
                            >
                              {t("save_changes")}
                              {/* {isLoading ? "Saving..." : "Save changes"} */}
                            </button>
                          </div>
                        </div>
                      )}

                      {/* Need help? tab */}
                      <div className={`tab-pane fade ${activeTab === "help-setting" ? "show active" : ""}`}>
                        <div className="help-content text-center my-4">
                          <div className="help-cta d-inline-flex align-items-center mb-4">
                            <span className="help-cta-avatar">
                              <img src={helpTabIcon} alt="" className="img-fluid" />
                            </span>
                            <a
                              href="#"
                              className="main-btn fill-green-btn help-cta-btn"
                              onClick={(e) => { e.preventDefault(); handleHelpGoToHelpCentre(); }}
                            >
                              {t("go_to_help_centre")}
                            </a>
                          </div>
                          <p>{t("react_help_form_subtitle")}</p>
                        </div>

                        <div className="setting-form-details need-help-form">
                          {/* Help-centre call to action: avatar + button as one pill */}

                          <div className="height-wrapper">
                            <form className="form-elements pt-1">
                              <div className="row">
                                {/* Short description */}
                                <div className="col-md-12">
                                  <div className="form-group mb-3">
                                    <label htmlFor="help-short-description">{t("short_description")}</label>
                                    <input
                                      type="text"
                                      id="help-short-description"
                                      className={`form-control ${helpErrors.shortDescription ? "error-form" : ""}`}
                                      name="shortDescription"
                                      value={helpForm.shortDescription}
                                      onChange={handleHelpInputChange}
                                    />
                                    {helpErrors.shortDescription && (
                                      <div className="error-text"><img src={Images.ErrorMsg} alt="" /> <p>{helpErrors.shortDescription}</p></div>
                                    )}
                                  </div>
                                </div>

                                {/* Message / steps to reproduce */}
                                <div className="col-md-12">
                                  <div className="form-group mb-3">
                                    <label htmlFor="help-steps-to-reproduce">{t("steps_to_reproduce")}</label>
                                    <textarea
                                      id="help-steps-to-reproduce"
                                      className={`form-control ${helpErrors.stepsToReproduce ? "error-form" : ""}`}
                                      name="stepsToReproduce"
                                      rows={6}
                                      value={helpForm.stepsToReproduce}
                                      onChange={handleHelpInputChange}
                                    />
                                    {helpErrors.stepsToReproduce && (
                                      <div className="error-text"><img src={Images.ErrorMsg} alt="" /> <p>{helpErrors.stepsToReproduce}</p></div>
                                    )}
                                  </div>
                                </div>

                                {/* Attachments: upload box (left) + uploaded file cards (right) */}
                                <div className="col-md-12">
                                  <div className="row">

                                    <div className="col-6">
                                      <div className="ctm-file-upload-box help-attach-upload">
                                        <input
                                          type="file"
                                          id="fileUpload"
                                          className="d-none"
                                          accept=".jpg,.jpeg,.png,.tiff,.tif,image/jpeg,image/png,image/tiff"
                                          multiple
                                          onChange={handleHelpFileChange}
                                          disabled={helpFiles.length >= MAX_HELP_FILES}
                                        />
                                        <label
                                          htmlFor="fileUpload"
                                          className="upload-box w-100"
                                          style={helpFiles.length >= MAX_HELP_FILES ? { opacity: 0.5, pointerEvents: "none" } : undefined}
                                        >
                                          <div className="file-upload-img">
                                            <img src={fileUploadIcon} alt="File Upload Icon" />
                                          </div>
                                          <span id="fileName">{t("react_attach_files")}</span>
                                          <small>({t("maximum_file_size_s").replace("%s", `${MAX_HELP_FILE_SIZE_MB} MB`)})</small>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="col-6">
                                      {helpFiles.length > 0 && (
                                        <ul className="uploaded-file-list help-attach-list list-unstyled mb-0">
                                          {helpFiles.map((file, index) => (
                                            <li key={`${file.name}-${index}`} className="uploaded-file-card d-flex align-items-center justify-content-between">
                                              <div className="file-card-info d-flex align-items-center">
                                                <span className="file-card-icon">
                                                  <img src={Images.Document} alt="" />
                                                </span>
                                                <div className="file-card-meta">
                                                  <span className="file-card-name text-truncate">{file.name}</span>
                                                  <small className="file-card-size">{formatFileSize(file.size)}</small>
                                                </div>
                                              </div>
                                              <div className="file-card-actions d-flex align-items-center">
                                                <button
                                                  type="button"
                                                  className="file-card-view p-0 border-0 bg-transparent"
                                                  onClick={() => handleViewHelpFile(file)}
                                                >
                                                  {t("click_to_view")}
                                                </button>
                                                <button
                                                  type="button"
                                                  className="file-card-remove p-0 border-0 bg-transparent"
                                                  onClick={() => handleRemoveHelpFile(index)}
                                                  aria-label={t("remove")}
                                                >
                                                  <img src={Images.BtnBlackTrash} alt={t("remove")} />
                                                </button>
                                              </div>
                                            </li>
                                          ))}
                                        </ul>
                                      )}
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </form>
                          </div>
                        </div>
                        <div className="bottom-action-btn d-flex justify-content-end tags-btn gap-3 mt-4">
                          <button onClick={() => { handleHelpCancel(); setActiveTab("profile-setting"); }} type="button" className="gray-outline-btn">{t("cancel")}</button>
                          <button
                            type="button"
                            className="selected"
                            onClick={handleHelpSend}
                          >
                            {t("react_send")}
                          </button>
                        </div>
                      </div>


                      {/* {(notification && !isLoading) && (
                        <NotificationMessage
                          type={notification.type}
                          title={notification.title}
                          message={notification.message}
                          duration={6000}
                          onClose={() => setNotification(null)}
                        />
                      )} */}
                      {renderApiUi(isLoading)}

                      {/* Delete account confirmation popup (root-level mount, mirrors NewMeetingModal) */}
                      {showDeleteAccountModal && (
                        <DeleteAccount
                          show={true}
                          onClose={handleDeleteAccountModalClose}
                          onConfirm={() => { /* API wiring deferred per request */ }}
                        />
                      )}


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
